/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> =
  { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any };
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any };
};

export enum AccountType {
  Artisan = "Artisan",
  Business = "Business",
  Homeowner = "Homeowner",
}

export type AddCategorySubscriptionPackagePriceIntervalChange = {
  discount: Scalars["Float"]["input"];
  interval: SubscriptionInterval;
};

export type AddJobsToOrderInput = {
  cartItems: Array<OrderCartItem>;
  location: JobLocationData;
};

export type AddLocationInput = {
  area: Scalars["String"]["input"];
  buildingNumber: Scalars["String"]["input"];
  city: Scalars["String"]["input"];
  landmark: Scalars["String"]["input"];
  location: Scalars["String"]["input"];
  streetName: Scalars["String"]["input"];
};

export type AddRewardPointChangeInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  point: Scalars["Int"]["input"];
  tradesmanId: Scalars["String"]["input"];
};

export type AddressInput = {
  address: Scalars["String"]["input"];
  city?: InputMaybe<Scalars["String"]["input"]>;
  coordinates?: InputMaybe<Array<Scalars["Float"]["input"]>>;
  formattedAddress: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["String"]["input"]>;
  placeId?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
};

export type AnalyticsDateRange = {
  endDate: Scalars["DateTimeISO"]["input"];
  startDate: Scalars["DateTimeISO"]["input"];
};

export enum ApplicationStatus {
  Drafted = "DRAFTED",
  Hired = "HIRED",
  OfferAccepted = "OFFER_ACCEPTED",
  OfferDeclined = "OFFER_DECLINED",
  OfferMade = "OFFER_MADE",
  Rejected = "REJECTED",
  Shortlisted = "SHORTLISTED",
  Submitted = "SUBMITTED",
  Viewed = "VIEWED",
}

export type ApproveAssignmentPaymentInput = {
  assignmentPaymentId: Scalars["String"]["input"];
  providerId: Scalars["String"]["input"];
};

export type ApproveRefundRequestInput = {
  providerId: Scalars["String"]["input"];
  refundRequestId: Scalars["String"]["input"];
};

export enum ArtisanInvoiceStatus {
  Cancelled = "CANCELLED",
  Draft = "DRAFT",
  Paid = "PAID",
  Pending = "PENDING",
}

export type AssignJobsToTradesmanInput = {
  date: Scalars["DateTimeISO"]["input"];
  jobIds: Array<Scalars["String"]["input"]>;
  orderId: Scalars["String"]["input"];
  tradesmanId: Scalars["String"]["input"];
};

export enum AssignmentPaymentTypes {
  Labor = "LABOR",
  Materials = "MATERIALS",
  Transportation = "TRANSPORTATION",
}

export enum AssignmentProgress {
  Assigned = "ASSIGNED",
  ClientInspection = "CLIENT_INSPECTION",
  ClientInspectionCompleted = "CLIENT_INSPECTION_COMPLETED",
  Completed = "COMPLETED",
  FinalQuote = "FINAL_QUOTE",
  MaterialsPurchased = "MATERIALS_PURCHASED",
  NotStarted = "NOT_STARTED",
  PreInspection = "PRE_INSPECTION",
  UnAssigned = "UN_ASSIGNED",
}

export enum Availability {
  Available = "AVAILABLE",
  Engaged = "ENGAGED",
  Tentative = "TENTATIVE",
}

export type BankAccountInformationInput = {
  accountNumber: Scalars["String"]["input"];
  bankCode: Scalars["String"]["input"];
  proId?: InputMaybe<Scalars["String"]["input"]>;
  providerId?: InputMaybe<Scalars["String"]["input"]>;
  referrerId?: InputMaybe<Scalars["String"]["input"]>;
};

export type BatchUpdateCandidateStatusDto = {
  candidateIds: Array<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  rejectionReason?: InputMaybe<Scalars["String"]["input"]>;
  status: TalentPoolCandidateStatus;
};

export type BusinessMetadataInput = {
  activated?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum CanadaBasicApplicationCitizenship {
  Nigerian = "NIGERIAN",
  Other = "OTHER",
}

export enum CanadaBasicApplicationCourseOfStudy {
  Bim = "BIM",
  CarpentryAndRenovationTechnician = "CARPENTRY_AND_RENOVATION_TECHNICIAN",
  CncTechnician = "CNC_TECHNICIAN",
  ConstructionEngineeringTechnician = "CONSTRUCTION_ENGINEERING_TECHNICIAN",
  ConstructionManagement = "CONSTRUCTION_MANAGEMENT",
  ElectricalTechniques = "ELECTRICAL_TECHNIQUES",
  ElectromechanicalEngineeringTechnician = "ELECTROMECHANICAL_ENGINEERING_TECHNICIAN",
  HeatingRefrigerationAcTechnician = "HEATING_REFRIGERATION_AC_TECHNICIAN",
  WeldingTechniques = "WELDING_TECHNIQUES",
}

export enum CanadaBasicApplicationEducationLevel {
  Bachelors = "BACHELORS",
  Doctorate = "DOCTORATE",
  Hnd = "HND",
  Kcse = "KCSE",
  Masters = "MASTERS",
  Ond = "OND",
  Ssce = "SSCE",
}

export type CancelTransferRequestInput = {
  transferRequestId: Scalars["String"]["input"];
};

export enum CardAuthorizationStatus {
  Authorized = "AUTHORIZED",
  Failed = "FAILED",
  Pending = "PENDING",
}

export type CategorySubscriptionPackagePlanCostBreakdownDiscountOptions = {
  maxAmount?: InputMaybe<Scalars["Float"]["input"]>;
  percentage: Scalars["Float"]["input"];
};

export enum CertificationRequirementType {
  Certification = "CERTIFICATION",
  PracticalAssessment = "PRACTICAL_ASSESSMENT",
  TheoreticalAssessment = "THEORETICAL_ASSESSMENT",
}

export type CheckTradesmenAvailabilityByDate = {
  date: Scalars["DateTimeISO"]["input"];
  tradesmanIds: Array<Scalars["String"]["input"]>;
};

export type ClientLocation = {
  area?: InputMaybe<Scalars["String"]["input"]>;
  buildingNumber?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  landmark?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  streetName?: InputMaybe<Scalars["String"]["input"]>;
};

export enum ClientProfile {
  Business = "BUSINESS",
  Homeowner = "HOMEOWNER",
}

export type ClientRefundData = {
  accountNumber: Scalars["String"]["input"];
  bankCode: Scalars["String"]["input"];
};

export enum CommunicationChannel {
  Email = "EMAIL",
  Sms = "SMS",
}

export enum CommunityAnnouncementStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
  Draft = "DRAFT",
}

export enum CommunityAnnouncementType {
  GeneralUpdate = "GENERAL_UPDATE",
  JobOpportunity = "JOB_OPPORTUNITY",
  TrainingEvent = "TRAINING_EVENT",
}

export type CommunityManagementDemoRequestDto = {
  communitySize: Scalars["String"]["input"];
  communityTalent: Array<CommunityTalent>;
  digitalToolsUsed?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  majorChallenges: Scalars["String"]["input"];
  organization: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
  preferredDemoDate: Scalars["DateTimeISO"]["input"];
  preferredDemoTime: Scalars["String"]["input"];
  roleInOrganization: Scalars["String"]["input"];
  typeOfCommunity: Scalars["String"]["input"];
};

export type CommunityManagementSalesConversationRequestDto = {
  communitySize: Scalars["String"]["input"];
  communityTalent: Array<CommunityTalent>;
  digitalToolsUsed?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  majorChallenges: Scalars["String"]["input"];
  organization: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
  preferredSalesConversationDate: Scalars["DateTimeISO"]["input"];
  preferredSalesConversationTime: Scalars["String"]["input"];
  roleInOrganization: Scalars["String"]["input"];
  typeOfCommunity: Scalars["String"]["input"];
};

export enum CommunitySegmentStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
}

export enum CommunityTalent {
  Alumni = "ALUMNI",
  CurrentStudents = "CURRENT_STUDENTS",
  RecentGraduates = "RECENT_GRADUATES",
}

export enum CompanySize {
  Enterprise = "ENTERPRISE",
  ExtraLarge = "EXTRA_LARGE",
  Large = "LARGE",
  Medium = "MEDIUM",
  Small = "SMALL",
}

export type ConstructionProjectRequestDto = {
  contactInfo: ContactInfoInput;
  estimatedArtisanCount: Scalars["Float"]["input"];
  includeMaterialsInCost?: InputMaybe<Scalars["Boolean"]["input"]>;
  intendedDuration: SimpleDuration;
  organizationInfo?: InputMaybe<OrganizationInfoInput>;
  otherTrade?: InputMaybe<Scalars["String"]["input"]>;
  projectLocation: Scalars["String"]["input"];
  trades: Array<ConstructionTrade>;
  willProvideMaterials: Scalars["Boolean"]["input"];
};

export enum ConstructionTrade {
  Carpentry = "CARPENTRY",
  Electrical = "ELECTRICAL",
  Masonry = "MASONRY",
  Other = "OTHER",
  Painting = "PAINTING",
  Plumbing = "PLUMBING",
  SolarInstallation = "SOLAR_INSTALLATION",
  Welding = "WELDING",
}

export type ContactInfoInput = {
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
};

export type ContractDetailsInput = {
  interval: ContractInterval;
  length: Scalars["Float"]["input"];
};

/** The contract interval */
export enum ContractInterval {
  Days = "DAYS",
  Months = "MONTHS",
  Weeks = "WEEKS",
}

export type ContractPayoutOverrideInput = {
  amount?: InputMaybe<Scalars["Float"]["input"]>;
  reason: Scalars["String"]["input"];
  tax?: InputMaybe<Scalars["Float"]["input"]>;
};

export type ContractQuotationItemInput = {
  categoryId: Scalars["String"]["input"];
  contractDetails: ContractDetailsInput;
  isActive: Scalars["Boolean"]["input"];
  level: Scalars["Float"]["input"];
  proCount: Scalars["Float"]["input"];
  rate?: InputMaybe<Scalars["Float"]["input"]>;
  requestedStartDate: Scalars["DateTimeISO"]["input"];
  workdays: Scalars["Float"]["input"];
};

export enum ContractStatus {
  Active = "ACTIVE",
  Cancelled = "CANCELLED",
  Pending = "PENDING",
}

export type CreateAdminInput = {
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  imageUrl: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  roles: Array<Role>;
};

export type CreateBusinessClientInput = {
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  password?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateCanadaBasicApplicationInput = {
  canCoverMinimumDeposit?: InputMaybe<Scalars["Boolean"]["input"]>;
  citizenship: CanadaBasicApplicationCitizenship;
  contributionAmountInCAD?: InputMaybe<Scalars["Float"]["input"]>;
  countryOfStudy: Scalars["String"]["input"];
  educationLevel: CanadaBasicApplicationEducationLevel;
  graduationYear: Scalars["Float"]["input"];
  hasInternationalPassport: Scalars["Boolean"]["input"];
  intendedCourseOfStudy: CanadaBasicApplicationCourseOfStudy;
  intendedProficiencyTestDate?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  intendedStudyResumptionDate: Scalars["DateTimeISO"]["input"];
  needsLoan: Scalars["Boolean"]["input"];
  passportExpiryDate?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  passportIssueDate?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  passportNumber?: InputMaybe<Scalars["String"]["input"]>;
  takenEnglishProficiencyTest: Scalars["Boolean"]["input"];
  testCompletionScore?: InputMaybe<Scalars["Float"]["input"]>;
  testCompletionYear?: InputMaybe<Scalars["Float"]["input"]>;
};

export type CreateCertificationInput = {
  description: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  requirements: Array<CreateCertificationRequirementInput>;
};

export type CreateCertificationRequirementInput = {
  description: Scalars["String"]["input"];
  lmsCourseExternalId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  order: Scalars["Float"]["input"];
  passingScore: Scalars["Float"]["input"];
  type: CertificationRequirementType;
};

export type CreateClientInput = {
  businessMetadata?: InputMaybe<BusinessMetadataInput>;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  imageUrl?: InputMaybe<Scalars["String"]["input"]>;
  isBusinessClient?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName: Scalars["String"]["input"];
  leadSource?: InputMaybe<LeadSource>;
  location?: InputMaybe<ClientLocation>;
  otherLeadSourceText?: InputMaybe<Scalars["String"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  referralCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateCommunityAnnouncementInput = {
  communicationChannels: Array<CommunicationChannel>;
  content: Scalars["String"]["input"];
  jobOpportunityId?: InputMaybe<Scalars["String"]["input"]>;
  targetSegmentIds: Array<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
  type: CommunityAnnouncementType;
};

export type CreateCommunityJobApplicationDto = {
  certificationItems?: Array<CreateJobApplicationCertificationDto>;
  educationItems?: Array<CreateJobApplicationEducationDto>;
  employmentHistoryItems?: Array<CreateJobApplicationEmploymentHistoryDto>;
  jobOpportunityId: Scalars["String"]["input"];
  projectHistoryItems?: Array<CreateJobApplicationProjectHistoryDto>;
};

export type CreateCommunityJobOpportunityInput = {
  applicationDeadline?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  description: Scalars["String"]["input"];
  duration?: InputMaybe<DurationDetailsInput>;
  employmentType: EmploymentType;
  location: JobLocationInput;
  salary?: InputMaybe<SalaryDetailsInput>;
  tagIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  title: Scalars["String"]["input"];
};

export type CreateCommunityManagerPaymentRequestArgs = {
  billingFrequency: Scalars["String"]["input"];
  message: Scalars["String"]["input"];
  preferredDate?: InputMaybe<Scalars["String"]["input"]>;
  preferredTime?: InputMaybe<Scalars["String"]["input"]>;
  requestType: Scalars["String"]["input"];
};

export type CreateCommunitySegmentInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  memberIds: Array<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
};

export type CreateContactsInput = {
  guarantors: Array<GuarantorInput>;
  referees: Array<RefereeInput>;
};

export type CreateContractRecruitmentInput = {
  businessId?: InputMaybe<Scalars["String"]["input"]>;
  clientId: Scalars["String"]["input"];
  clientProfile: ClientProfile;
  location: LocationDataInput;
  paymentSchedule: PaymentSchedule;
  recruitmentType: RecruitmentType;
  requests: Array<RecruitmentRequestInput>;
};

export type CreateIdentityVerificationDto = {
  dateOfBirth: Scalars["DateTimeISO"]["input"];
  identificationNumber: Scalars["String"]["input"];
  proId: Scalars["String"]["input"];
  type: MeansOfIdentification;
};

export type CreateInviteInput = {
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  level?: InputMaybe<Scalars["Float"]["input"]>;
  userType: UserType;
};

export type CreateJobApplicationCertificationDto = {
  issuedAt: Scalars["DateTimeISO"]["input"];
  issuedBy: Scalars["String"]["input"];
  issuerCertificationId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateJobApplicationDto = {
  ad: Scalars["String"]["input"];
  certificationItems: Array<CreateJobApplicationCertificationDto>;
  educationItems: Array<CreateJobApplicationEducationDto>;
  email: Scalars["String"]["input"];
  employmentHistoryItems: Array<CreateJobApplicationEmploymentHistoryDto>;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  projectHistoryItems: Array<CreateJobApplicationProjectHistoryDto>;
  yearsOfExperience: Scalars["Float"]["input"];
};

export type CreateJobApplicationEducationDto = {
  fieldOfStudy?: InputMaybe<Scalars["String"]["input"]>;
  qualification: EducationLevel;
  schoolName: Scalars["String"]["input"];
};

export type CreateJobApplicationEmploymentHistoryDto = {
  companyName: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  endedAt?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  jobTitle: Scalars["String"]["input"];
  media?: InputMaybe<Array<JobApplicationMediaItemInput>>;
  startedAt: Scalars["DateTimeISO"]["input"];
};

export type CreateJobApplicationProjectHistoryDto = {
  description: Scalars["String"]["input"];
  endedAt: Scalars["DateTimeISO"]["input"];
  media?: InputMaybe<Array<JobApplicationMediaItemInput>>;
  name: Scalars["String"]["input"];
  startedAt?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  videos?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type CreateMarketplaceRequestInput = {
  jobs: Array<CreateMarketplaceRequestJobInput>;
  location: LocationDataInput;
};

export type CreateMarketplaceRequestJobInput = {
  /** A description of the job to help the pros make a decision. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The number of pros required for this job. */
  proCount: Scalars["Float"]["input"];
  schedule: CreateMarketplaceRequestJobScheduleInput;
  /** The trade id. This can be gotten from the trades query. Only trades that are enabled for the marketplace can be used. */
  tradeId: Scalars["String"]["input"];
};

export type CreateMarketplaceRequestJobScheduleInput = {
  end: Scalars["DateTimeISO"]["input"];
  /** An array of dates the pro(s) are not required to work within the start and end dates. To ignore all occurences of a weekday, see the workDays field. */
  offDates?: InputMaybe<Array<Scalars["DateTimeISO"]["input"]>>;
  start: Scalars["DateTimeISO"]["input"];
  /** An array of days in week the pro(s) are required to work. For example: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'] means the pros are not needed weekends. */
  workDays: Array<Scalars["String"]["input"]>;
};

export type CreateMaterialsInvoiceInput = {
  allowedPaymentProviders: Array<Scalars["String"]["input"]>;
  assignmentIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  commissionPercentage?: InputMaybe<Scalars["Float"]["input"]>;
  customMaterialCommissionCap?: InputMaybe<Scalars["Float"]["input"]>;
  jobUpdates?: InputMaybe<Array<JobInvoiceDetailsItem>>;
  quotationId?: InputMaybe<Scalars["String"]["input"]>;
  splits?: InputMaybe<Array<Scalars["Float"]["input"]>>;
};

export type CreateOrderHandlingQuotationItem = {
  jobId: Scalars["String"]["input"];
  labor?: InputMaybe<Scalars["Float"]["input"]>;
  materials?: InputMaybe<Array<CreateOrderHandlingQuotationItemMaterial>>;
};

export type CreateOrderHandlingQuotationItemMaterial = {
  name: Scalars["String"]["input"];
  quantity: Scalars["Int"]["input"];
  unitPrice: Scalars["Float"]["input"];
};

export type CreateOrganizationDetailsInput = {
  adminEmail?: InputMaybe<Scalars["String"]["input"]>;
  countryCode?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  organizationName?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateOrganizationTalentPoolDto = {
  communityMemberIds: Array<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
};

export type CreateProApplicationDto = {
  address: Scalars["String"]["input"];
  categoryId: Scalars["String"]["input"];
  channelOutreachSourceId?: InputMaybe<Scalars["String"]["input"]>;
  country: Scalars["String"]["input"];
  dateOfBirth: Scalars["DateTimeISO"]["input"];
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  gender: Gender;
  incomeLevel: IncomeLevel;
  lastName: Scalars["String"]["input"];
  leadSource: Scalars["String"]["input"];
  locationOutreachSourceId?: InputMaybe<Scalars["String"]["input"]>;
  numberOfDaysWorkedPerWeek: Scalars["Int"]["input"];
  otherCategoryText?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber: Scalars["String"]["input"];
  referredBy?: InputMaybe<Scalars["String"]["input"]>;
  stateOfResidence: Scalars["String"]["input"];
  trainingType: TrainingType;
  yearsOfExperience?: InputMaybe<Scalars["Float"]["input"]>;
};

export type CreateProFromInviteInput = {
  accountNumber: Scalars["String"]["input"];
  bankCode: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  imageUrl: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  location?: InputMaybe<ProLocation>;
  phoneNumber: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
};

export type CreateProRecruitmentContractInput = {
  paymentAmount: Scalars["Int"]["input"];
  paymentMethod: PaymentMethod;
  proId: Scalars["String"]["input"];
  recruitmentJobId: Scalars["String"]["input"];
  startDate: Scalars["DateTimeISO"]["input"];
  unitMeasured: Scalars["String"]["input"];
};

export type CreateProductFeedbackDto = {
  feedback: Scalars["String"]["input"];
  product: LaborHackProduct;
};

export type CreateRefundRequestInput = {
  clientRefundData?: InputMaybe<ClientRefundData>;
  jobsToRefund: Array<JobToRefund>;
  orderId: Scalars["String"]["input"];
  reason: Scalars["String"]["input"];
  tradesmanPointChanges: Array<PointChange>;
};

export type CreateReviewInput = {
  appearance: Scalars["Float"]["input"];
  assignmentId: Scalars["String"]["input"];
  behavior: Scalars["Float"]["input"];
  feedback: Scalars["String"]["input"];
  postServiceCleanUp: Scalars["Float"]["input"];
  properToolUsage: Scalars["Float"]["input"];
  punctuality: Scalars["Float"]["input"];
};

export type CreateThirdPartyInput = {
  adminEmail: Scalars["String"]["input"];
  countryCode: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  representedOrganizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateTradeInput = {
  categoryId: Scalars["String"]["input"];
  certificationId: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

export type CreateTradesmanInput = {
  accountNumber: Scalars["String"]["input"];
  bankCode: Scalars["String"]["input"];
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  imageUrl: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  level: Scalars["Int"]["input"];
  location?: InputMaybe<TradesmanLocation>;
  phoneNumber: Scalars["String"]["input"];
};

export type CreateTrainingCommunityProgramInput = {
  enableLogBookReporting: Scalars["Boolean"]["input"];
  endDate: Scalars["String"]["input"];
  invitedSupervisorEmails?: InputMaybe<Array<Scalars["String"]["input"]>>;
  logBookReportingFrequency?: InputMaybe<LogBookReportingFrequency>;
  name: Scalars["String"]["input"];
  startDate: Scalars["String"]["input"];
  supervisorIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type CreateWaitlistedBusinessInput = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  contactName: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  state?: InputMaybe<Scalars["String"]["input"]>;
};

export type CustomLocation = {
  area?: InputMaybe<Scalars["String"]["input"]>;
  buildingNumber?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  landmark?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  streetName?: InputMaybe<Scalars["String"]["input"]>;
};

export enum CustomSubscriptionRequestAccountType {
  Artisan = "Artisan",
  Business = "Business",
  Homeowner = "Homeowner",
}

/** The status of a direct debit authorization */
export enum DirectDebitAuthorizationStatus {
  Active = "ACTIVE",
  ClientApproved = "CLIENT_APPROVED",
  Initialized = "INITIALIZED",
}

export type DurationDetailsInput = {
  type: DurationType;
  value: Scalars["Float"]["input"];
};

export enum DurationType {
  Days = "DAYS",
  Months = "MONTHS",
  Weeks = "WEEKS",
  Years = "YEARS",
}

export type EditAdminInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type EditClientInput = {
  businessMetadata?: InputMaybe<BusinessMetadataInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  lastNotificationViewedAt?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type EditCustomTaskInput = {
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  jobId: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type EditSubCategoryInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  imageUrl?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  subCategoryId?: InputMaybe<Scalars["String"]["input"]>;
};

export type EditTaskInput = {
  description: Scalars["String"]["input"];
  estimatedCost: Scalars["Float"]["input"];
  imageUrl: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  taskId?: InputMaybe<Scalars["String"]["input"]>;
};

export type EditTradesmanInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export enum EducationLevel {
  Bachelors = "BACHELORS",
  Doctorate = "DOCTORATE",
  Hnd = "HND",
  Jssce = "JSSCE",
  Kcse = "KCSE",
  Masters = "MASTERS",
  Nabteb = "NABTEB",
  Ond = "OND",
  Ssce = "SSCE",
}

export enum EmployerJobAdStatus {
  Active = "ACTIVE",
  Disabled = "DISABLED",
  InReview = "IN_REVIEW",
  Rejected = "REJECTED",
  Stopped = "STOPPED",
}

export enum EmployerJobAdsDateFilter {
  AllTime = "ALL_TIME",
  LastMonth = "LAST_MONTH",
  LastWeek = "LAST_WEEK",
  Yesterday = "YESTERDAY",
}

export enum EmploymentContractUnit {
  Day = "DAY",
  Month = "MONTH",
  Week = "WEEK",
  Year = "YEAR",
}

export type EmploymentHiringTermsInput = {
  contractLength?: InputMaybe<Scalars["Int"]["input"]>;
  contractUnit?: InputMaybe<EmploymentContractUnit>;
  employmentType: EmploymentType;
  salary?: InputMaybe<Scalars["Float"]["input"]>;
  salaryUnit?: InputMaybe<EmploymentSalaryUnit>;
  startDate?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export enum EmploymentSalaryUnit {
  Day = "DAY",
  Hour = "HOUR",
  LumpSum = "LUMP_SUM",
  Month = "MONTH",
  Week = "WEEK",
  Year = "YEAR",
}

export enum EmploymentStatus {
  Employed = "EMPLOYED",
  SelfEmployed = "SELF_EMPLOYED",
  Student = "STUDENT",
  Unemployed = "UNEMPLOYED",
}

export enum EmploymentType {
  Contract = "CONTRACT",
  FullTime = "FULL_TIME",
}

export enum EventTypes {
  AdminActivatedEmployerJobAd = "ADMIN_ACTIVATED_EMPLOYER_JOB_AD",
  AdminChangedJobAdApplicationDeadline = "ADMIN_CHANGED_JOB_AD_APPLICATION_DEADLINE",
  AdminDisabledEmployerJobAd = "ADMIN_DISABLED_EMPLOYER_JOB_AD",
  AdminRejectedEmployerJobAd = "ADMIN_REJECTED_EMPLOYER_JOB_AD",
  ArtisanAssistBankDetailsSubmitted = "ARTISAN_ASSIST_BANK_DETAILS_SUBMITTED",
  ArtisanAssistBusinessProfileCreated = "ARTISAN_ASSIST_BUSINESS_PROFILE_CREATED",
  ArtisanAssistClientUpdated = "ARTISAN_ASSIST_CLIENT_UPDATED",
  ArtisanAssistInvoiceCancelled = "ARTISAN_ASSIST_INVOICE_CANCELLED",
  ArtisanAssistInvoiceClientDetailsSet = "ARTISAN_ASSIST_INVOICE_CLIENT_DETAILS_SET",
  ArtisanAssistInvoiceCreated = "ARTISAN_ASSIST_INVOICE_CREATED",
  ArtisanAssistInvoiceDraftStarted = "ARTISAN_ASSIST_INVOICE_DRAFT_STARTED",
  ArtisanAssistInvoiceJobDescriptionSet = "ARTISAN_ASSIST_INVOICE_JOB_DESCRIPTION_SET",
  ArtisanAssistInvoiceLaborFeeSet = "ARTISAN_ASSIST_INVOICE_LABOR_FEE_SET",
  ArtisanAssistInvoiceMaterialsSet = "ARTISAN_ASSIST_INVOICE_MATERIALS_SET",
  ArtisanAssistInvoicePaymentReceived = "ARTISAN_ASSIST_INVOICE_PAYMENT_RECEIVED",
  ArtisanAssistProAccountCreated = "ARTISAN_ASSIST_PRO_ACCOUNT_CREATED",
  ArtisanAssistUserCreated = "ARTISAN_ASSIST_USER_CREATED",
  CommunityAnnouncementCreated = "COMMUNITY_ANNOUNCEMENT_CREATED",
  CommunityAnnouncementPublished = "COMMUNITY_ANNOUNCEMENT_PUBLISHED",
  CommunityJobApplicationHired = "COMMUNITY_JOB_APPLICATION_HIRED",
  CommunityJobApplicationRejected = "COMMUNITY_JOB_APPLICATION_REJECTED",
  CommunityJobApplicationSubmitted = "COMMUNITY_JOB_APPLICATION_SUBMITTED",
  CommunityJobOpportunityCreated = "COMMUNITY_JOB_OPPORTUNITY_CREATED",
  CommunityManagementDemoRequestTaskCreated = "COMMUNITY_MANAGEMENT_DEMO_REQUEST_TASK_CREATED",
  CommunityManagementSalesConversationTaskCreated = "COMMUNITY_MANAGEMENT_SALES_CONVERSATION_TASK_CREATED",
  CommunityManagerPaymentReceived = "COMMUNITY_MANAGER_PAYMENT_RECEIVED",
  CommunityManagerPaymentRequestCreated = "COMMUNITY_MANAGER_PAYMENT_REQUEST_CREATED",
  CommunitySegmentCreated = "COMMUNITY_SEGMENT_CREATED",
  CustomSubscriptionRequestCreated = "CUSTOM_SUBSCRIPTION_REQUEST_CREATED",
  EligibleForStudyWorkOpportunity = "ELIGIBLE_FOR_STUDY_WORK_OPPORTUNITY",
  EmployerJobAdCreated = "EMPLOYER_JOB_AD_CREATED",
  EmployerJobAdResumed = "EMPLOYER_JOB_AD_RESUMED",
  EmployerJobAdShortlistFinalized = "EMPLOYER_JOB_AD_SHORTLIST_FINALIZED",
  EmployerJobAdShortlistNotified = "EMPLOYER_JOB_AD_SHORTLIST_NOTIFIED",
  EmployerJobAdStopped = "EMPLOYER_JOB_AD_STOPPED",
  EmployerJobApplicationEnhancementRequested = "EMPLOYER_JOB_APPLICATION_ENHANCEMENT_REQUESTED",
  EmployerJobApplicationHired = "EMPLOYER_JOB_APPLICATION_HIRED",
  EmployerJobApplicationRejected = "EMPLOYER_JOB_APPLICATION_REJECTED",
  EmployerJobApplicationRemovedFromShortlist = "EMPLOYER_JOB_APPLICATION_REMOVED_FROM_SHORTLIST",
  EmployerJobApplicationShortlisted = "EMPLOYER_JOB_APPLICATION_SHORTLISTED",
  EmployerJobApplicationShortlistFinalized = "EMPLOYER_JOB_APPLICATION_SHORTLIST_FINALIZED",
  EmployerJobApplicationStarted = "EMPLOYER_JOB_APPLICATION_STARTED",
  EmployerJobApplicationSubmitted = "EMPLOYER_JOB_APPLICATION_SUBMITTED",
  EnquiryCreated = "ENQUIRY_CREATED",
  ExternalAssessmentCreated = "EXTERNAL_ASSESSMENT_CREATED",
  FullTimeProSalaryUpdated = "FULL_TIME_PRO_SALARY_UPDATED",
  GuestJobApplicantProRegistration = "GUEST_JOB_APPLICANT_PRO_REGISTRATION",
  IdentitySubmissionDeclined = "IDENTITY_SUBMISSION_DECLINED",
  IdentitySubmissionVerified = "IDENTITY_SUBMISSION_VERIFIED",
  IneligibleForStudyWorkOpportunity = "INELIGIBLE_FOR_STUDY_WORK_OPPORTUNITY",
  InterviewRequirementCancelled = "INTERVIEW_REQUIREMENT_CANCELLED",
  InvoiceDiscountApplied = "INVOICE_DISCOUNT_APPLIED",
  InvoiceDiscountUsed = "INVOICE_DISCOUNT_USED",
  JobAdNotificationPreferencesCreated = "JOB_AD_NOTIFICATION_PREFERENCES_CREATED",
  JobAdNotificationPreferencesUpdated = "JOB_AD_NOTIFICATION_PREFERENCES_UPDATED",
  JobApplicationReminderEmailSent = "JOB_APPLICATION_REMINDER_EMAIL_SENT",
  LaborFeePaid = "LABOR_FEE_PAID",
  LlmTokenUsage = "LLM_TOKEN_USAGE",
  OfflinePaymentConfirmed = "OFFLINE_PAYMENT_CONFIRMED",
  OfflineTransferConfirmed = "OFFLINE_TRANSFER_CONFIRMED",
  OnboardingCompleted = "ONBOARDING_COMPLETED",
  OrganizationUserDisabled = "ORGANIZATION_USER_DISABLED",
  OrganizationUserEnabled = "ORGANIZATION_USER_ENABLED",
  OrganizationUserInviteCancelled = "ORGANIZATION_USER_INVITE_CANCELLED",
  OutOfLagosHomeownerRequestAttempt = "OUT_OF_LAGOS_HOMEOWNER_REQUEST_ATTEMPT",
  ProjectOutsourcingTaskCreated = "PROJECT_OUTSOURCING_TASK_CREATED",
  ProAcceptedMarketplaceJob = "PRO_ACCEPTED_MARKETPLACE_JOB",
  ProAcceptedRecruitmentJob = "PRO_ACCEPTED_RECRUITMENT_JOB",
  ProAccountMerged = "PRO_ACCOUNT_MERGED",
  ProBackgroundCheckSubmitted = "PRO_BACKGROUND_CHECK_SUBMITTED",
  ProBankDetailsSubmitted = "PRO_BANK_DETAILS_SUBMITTED",
  ProCompletedAssessment = "PRO_COMPLETED_ASSESSMENT",
  ProDeclinedMarketplaceJob = "PRO_DECLINED_MARKETPLACE_JOB",
  ProNotifiedOfJobAdShortlisting = "PRO_NOTIFIED_OF_JOB_AD_SHORTLISTING",
  ProPortfolioReminderEmailSent = "PRO_PORTFOLIO_REMINDER_EMAIL_SENT",
  ProShortlistedForMarketplaceJob = "PRO_SHORTLISTED_FOR_MARKETPLACE_JOB",
  ProShortlistedForRecruitmentJob = "PRO_SHORTLISTED_FOR_RECRUITMENT_JOB",
  ProTrackAdded = "PRO_TRACK_ADDED",
  ProWebsiteCertificationAdded = "PRO_WEBSITE_CERTIFICATION_ADDED",
  ProWebsiteCertificationRemoved = "PRO_WEBSITE_CERTIFICATION_REMOVED",
  ProWebsiteCertificationUpdated = "PRO_WEBSITE_CERTIFICATION_UPDATED",
  ProWebsiteEducationAdded = "PRO_WEBSITE_EDUCATION_ADDED",
  ProWebsiteEducationRemoved = "PRO_WEBSITE_EDUCATION_REMOVED",
  ProWebsiteEducationUpdated = "PRO_WEBSITE_EDUCATION_UPDATED",
  ProWebsiteEmploymentHistoryAdded = "PRO_WEBSITE_EMPLOYMENT_HISTORY_ADDED",
  ProWebsiteEmploymentHistoryRemoved = "PRO_WEBSITE_EMPLOYMENT_HISTORY_REMOVED",
  ProWebsiteEmploymentHistoryUpdated = "PRO_WEBSITE_EMPLOYMENT_HISTORY_UPDATED",
  ProWebsiteProfileGenerated = "PRO_WEBSITE_PROFILE_GENERATED",
  ProWebsiteWorkExperienceAdded = "PRO_WEBSITE_WORK_EXPERIENCE_ADDED",
  ProWebsiteWorkExperienceRemoved = "PRO_WEBSITE_WORK_EXPERIENCE_REMOVED",
  ProWebsiteWorkExperienceUpdated = "PRO_WEBSITE_WORK_EXPERIENCE_UPDATED",
  RecruitmentConsultationTaskCreated = "RECRUITMENT_CONSULTATION_TASK_CREATED",
  RecruitToolSalesConversationTaskCreated = "RECRUIT_TOOL_SALES_CONVERSATION_TASK_CREATED",
  RelevantJobAdNotificationEmailSent = "RELEVANT_JOB_AD_NOTIFICATION_EMAIL_SENT",
  RequirementAttemptPaid = "REQUIREMENT_ATTEMPT_PAID",
  RequirementCompleted = "REQUIREMENT_COMPLETED",
  RequirementScheduled = "REQUIREMENT_SCHEDULED",
  RequirementStarted = "REQUIREMENT_STARTED",
  RequirementWaived = "REQUIREMENT_WAIVED",
  StartedFixMeRegistration = "STARTED_FIX_ME_REGISTRATION",
  StudyWorkAbroadPreferredCourseUpdated = "STUDY_WORK_ABROAD_PREFERRED_COURSE_UPDATED",
  SubscriptionCancelled = "SUBSCRIPTION_CANCELLED",
  TalentPoolCandidateHired = "TALENT_POOL_CANDIDATE_HIRED",
  TalentPoolCandidateInvitedToInterview = "TALENT_POOL_CANDIDATE_INVITED_TO_INTERVIEW",
  TalentPoolCandidateViewed = "TALENT_POOL_CANDIDATE_VIEWED",
  TalentPoolInstanceViewed = "TALENT_POOL_INSTANCE_VIEWED",
  TalentPoolOrganizationUserInviteCreated = "TALENT_POOL_ORGANIZATION_USER_INVITE_CREATED",
  TalentPoolShared = "TALENT_POOL_SHARED",
  TradeLevelCompleted = "TRADE_LEVEL_COMPLETED",
  TradeLevelUnlocked = "TRADE_LEVEL_UNLOCKED",
  TradeStarted = "TRADE_STARTED",
  WhatsappProEmailAuthSet = "WHATSAPP_PRO_EMAIL_AUTH_SET",
  WrongReferralCodeUsed = "WRONG_REFERRAL_CODE_USED",
}

export enum ExternalProTradeRequirementStatus {
  AwaitingResult = "AWAITING_RESULT",
  AwaitingUpload = "AWAITING_UPLOAD",
  Failed = "FAILED",
  NotPaid = "NOT_PAID",
  Passed = "PASSED",
}

export type FacilityMaintenanceRequestDto = {
  contactInfo: ContactInfoInput;
  facilityLocation: Scalars["String"]["input"];
  maintenanceFrequency?: InputMaybe<MaintenanceFrequency>;
  organizationInfo?: InputMaybe<OrganizationInfoInput>;
  otherService?: InputMaybe<Scalars["String"]["input"]>;
  planType: MaintenancePlanType;
  services: Array<FacilityService>;
};

export enum FacilityService {
  Carpentry = "CARPENTRY",
  Cleaning = "CLEANING",
  Electrical = "ELECTRICAL",
  Fumigation = "FUMIGATION",
  Hvac = "HVAC",
  Other = "OTHER",
  Painting = "PAINTING",
  Plumbing = "PLUMBING",
}

export type FinalizeAssignmentPaymentInput = {
  assignmentPaymentId: Scalars["String"]["input"];
  otp: Scalars["String"]["input"];
};

export enum Gender {
  Female = "FEMALE",
  Male = "MALE",
  Other = "OTHER",
}

export type GetAssignmentScheduleInput = {
  categoryId: Scalars["String"]["input"];
  endDate: Scalars["DateTimeISO"]["input"];
  startDate: Scalars["DateTimeISO"]["input"];
};

export type GetTradesmanWithAvailabilityByCategoryInput = {
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
  date: Scalars["DateTimeISO"]["input"];
};

export type GuarantorInput = {
  companyAddress: Scalars["String"]["input"];
  companyName: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  jobTitle: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  relationship: Scalars["String"]["input"];
};

export enum HomeownerRequestTaskFrequency {
  Daily = "DAILY",
  Monthly = "MONTHLY",
  Once = "ONCE",
  Weekly = "WEEKLY",
}

export enum IdentityVerificationIssueCode {
  DobMismatch = "DOB_MISMATCH",
  DuplicateId = "DUPLICATE_ID",
  InvalidId = "INVALID_ID",
  NameMismatch = "NAME_MISMATCH",
  PhoneMismatch = "PHONE_MISMATCH",
}

export enum IdentityVerificationStatus {
  Declined = "DECLINED",
  Pending = "PENDING",
  Verified = "VERIFIED",
}

export enum IncomeLevel {
  Between_30KAnd_50K = "BETWEEN_30K_AND_50K",
  Between_50KAnd_70K = "BETWEEN_50K_AND_70K",
  Between_70KAnd_100K = "BETWEEN_70K_AND_100K",
  Between_100KAnd_150K = "BETWEEN_100K_AND_150K",
  Between_150KAnd_200K = "BETWEEN_150K_AND_200K",
  Over_200K = "OVER_200K",
  Under_30K = "UNDER_30K",
}

export enum Industry {
  AerospaceAndDefense = "AerospaceAndDefense",
  AgricultureAndForestry = "AgricultureAndForestry",
  ArtsDesignAndFashion = "ArtsDesignAndFashion",
  Automotive = "Automotive",
  Construction = "Construction",
  Consulting = "Consulting",
  Education = "Education",
  EnergyAndUtilities = "EnergyAndUtilities",
  EnvironmentalServices = "EnvironmentalServices",
  FinanceAndBanking = "FinanceAndBanking",
  FoodAndBeverage = "FoodAndBeverage",
  GovernmentAndPublicAdministration = "GovernmentAndPublicAdministration",
  Healthcare = "Healthcare",
  HospitalityAndTourism = "HospitalityAndTourism",
  LawAndLegalServices = "LawAndLegalServices",
  Manufacturing = "Manufacturing",
  MarketingAndAdvertising = "MarketingAndAdvertising",
  MediaAndEntertainment = "MediaAndEntertainment",
  NonprofitAndSocialServices = "NonprofitAndSocialServices",
  Other = "Other",
  PharmaceuticalAndBiotechnology = "PharmaceuticalAndBiotechnology",
  RealEstate = "RealEstate",
  Retail = "Retail",
  TechnologyAndInformationServices = "TechnologyAndInformationServices",
  Telecommunications = "Telecommunications",
  TransportationAndLogistics = "TransportationAndLogistics",
}

export type InitiateAssignmentPaymentInput = {
  assignmentId: Scalars["String"]["input"];
  purpose: AssignmentPaymentTypes;
};

export type IntervalDiscountInput = {
  discountPercentage: Scalars["Float"]["input"];
  interval: SubscriptionInterval;
};

export type InvoiceMaterialInput = {
  name: Scalars["String"]["input"];
  quantity: Scalars["Float"]["input"];
  unitPrice: Scalars["Float"]["input"];
};

export enum InvoiceType {
  ContractPayoutReimbursement = "CONTRACT_PAYOUT_REIMBURSEMENT",
  Inspection = "INSPECTION",
  MarketplaceRequestMatch = "MARKETPLACE_REQUEST_MATCH",
  Materials = "MATERIALS",
  Recruitment = "RECRUITMENT",
  RecruitmentMatch = "RECRUITMENT_MATCH",
  Subscription = "SUBSCRIPTION",
}

export enum JobAdCommunicationMethod {
  Email = "EMAIL",
  Sms = "SMS",
  Whatsapp = "WHATSAPP",
}

export type JobApplicationMediaItemInput = {
  key: Scalars["String"]["input"];
  mimeType: Scalars["String"]["input"];
};

/** The Custom order */
export type JobCustomTaskInput = {
  categoryId: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  resourceUrl?: InputMaybe<Scalars["String"]["input"]>;
  subCategoryId?: InputMaybe<Scalars["String"]["input"]>;
};

export type JobImage = {
  data: Scalars["String"]["input"];
  mimeType: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

export type JobInvoiceDetailsItem = {
  jobId: Scalars["String"]["input"];
  labor?: InputMaybe<Scalars["Int"]["input"]>;
  materials?: InputMaybe<Array<InvoiceMaterialInput>>;
};

/** The location of Job */
export type JobLocationData = {
  customLocation?: InputMaybe<CustomLocation>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  scheduledDate: Scalars["DateTimeISO"]["input"];
};

export type JobLocationInput = {
  area: Scalars["String"]["input"];
  country: Scalars["String"]["input"];
  state: Scalars["String"]["input"];
};

export type JobTaskInput = {
  categoryId: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
};

export type JobToRefund = {
  amount: Scalars["Float"]["input"];
  assignmentId: Scalars["String"]["input"];
  jobId: Scalars["String"]["input"];
};

/** The visibility of the job ad */
export enum JobVisibility {
  Private = "PRIVATE",
  Public = "PUBLIC",
}

export enum LaborHackProduct {
  Recruiter = "RECRUITER",
  Training = "TRAINING",
}

export type LatLongInput = {
  latitude: Scalars["Float"]["input"];
  longitude: Scalars["Float"]["input"];
};

export enum LeadSource {
  Advertisement = "Advertisement",
  EventOrExhibition = "Event_or_Exhibition",
  FriendOrReferral = "Friend_or_Referral",
  GoogleAd = "Google_Ad",
  Herconomy = "Herconomy",
  Influencers = "Influencers",
  LaborHackMarketer = "LaborHack_Marketer",
  MarketingFlyer = "Marketing_Flyer",
  Newspaper = "Newspaper",
  OnlineSearch = "Online_Search",
  Other = "Other",
  Radio = "Radio",
  SalesTeam = "Sales_Team",
  SocialMedia = "Social_Media",
  Tv = "TV",
  Voucher = "Voucher",
  WordOfMouth = "Word_of_Mouth",
  Youtube = "Youtube",
}

export type ListAllTradesmenSearch = {
  by: ListAllTradesmenSearchBy;
  query: Scalars["String"]["input"];
};

export enum ListAllTradesmenSearchBy {
  Location = "LOCATION",
}

export type ListAssignmentPaymentFilters = {
  showOlderTransactions?: InputMaybe<Scalars["Boolean"]["input"]>;
  transferStatus?: InputMaybe<TransferStatus>;
};

export type ListAssignmentPaymentSearch = {
  type: ListAssignmentPaymentSearchTypes;
  value: Scalars["String"]["input"];
};

/** Search types for list assignment payment */
export enum ListAssignmentPaymentSearchTypes {
  OrderCode = "ORDER_CODE",
}

export type ListBusinessesFilters = {
  activated?: InputMaybe<Scalars["Boolean"]["input"]>;
  deliveryStatus?: InputMaybe<Array<SentEmailDeliveryStatus>>;
};

export type ListProCertificationsFilters = {
  certificationIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  identityVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  onlineAssessmentPassed?: InputMaybe<Scalars["Boolean"]["input"]>;
  uploaded?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListProTradeRequirementsFilters = {
  assessmentType?: InputMaybe<Array<TradeRequirementType>>;
  externalStatus?: InputMaybe<Array<ExternalProTradeRequirementStatus>>;
  identityVerificationStatus?: InputMaybe<
    Array<ListProsIdentityVerificationStatus>
  >;
  requirementIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ListProTradeRequirementsSearch = {
  by: ListProTradeRequirementsSearchBy;
  query: Scalars["String"]["input"];
};

export enum ListProTradeRequirementsSearchBy {
  Email = "EMAIL",
  FirstName = "FIRST_NAME",
  LastName = "LAST_NAME",
}

export type ListProTradeRequirementsSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  by: ListProTradeRequirementsSortBy;
};

export enum ListProTradeRequirementsSortBy {
  CreatedAt = "CREATED_AT",
}

export type ListProsFilters = {
  alternativeToPracticalInterviewStatus?: InputMaybe<Array<ListProsTestStatus>>;
  backgroundCheckComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  bankAccountSubmitted?: InputMaybe<Scalars["Boolean"]["input"]>;
  categoryIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  channelIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  excludedProIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  hasJobScheduleConflict?: InputMaybe<
    Array<ListProsForRecruitmentJobScheduleConflict>
  >;
  identityVerificationIssueCode?: InputMaybe<
    Array<ListProsIdentityVerificationIssueCode>
  >;
  identityVerificationStatus?: InputMaybe<
    Array<ListProsIdentityVerificationStatus>
  >;
  isLegacy?: InputMaybe<Scalars["Boolean"]["input"]>;
  isOnboarded?: InputMaybe<Scalars["Boolean"]["input"]>;
  leadSource?: InputMaybe<Array<Scalars["String"]["input"]>>;
  locationIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  onboardingCompleted?: InputMaybe<Array<Scalars["String"]["input"]>>;
  paidForPriorLearningAttempts?: InputMaybe<Scalars["Boolean"]["input"]>;
  paidForSoftSkillsAttempts?: InputMaybe<Scalars["Boolean"]["input"]>;
  priorLearningTestStatus?: InputMaybe<Array<ListProsTestStatus>>;
  softSkillsTrainingStatus?: InputMaybe<Array<ListProsTestStatus>>;
  tracks?: InputMaybe<Array<ProTrack>>;
  tradeId?: InputMaybe<Scalars["String"]["input"]>;
  tradeIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export enum ListProsForRecruitmentJobScheduleConflict {
  Available = "AVAILABLE",
  HasConflict = "HAS_CONFLICT",
}

export enum ListProsIdentityVerificationIssueCode {
  DobMismatch = "DOB_MISMATCH",
  DuplicateId = "DUPLICATE_ID",
  NameMismatch = "NAME_MISMATCH",
  NotAvailable = "NOT_AVAILABLE",
  PhoneMismatch = "PHONE_MISMATCH",
}

export enum ListProsIdentityVerificationStatus {
  Declined = "DECLINED",
  NotSubmitted = "NOT_SUBMITTED",
  Pending = "PENDING",
  Verified = "VERIFIED",
}

export type ListProsSearch = {
  by: ListProsSearchBy;
  query: Scalars["String"]["input"];
};

export enum ListProsSearchBy {
  Address = "ADDRESS",
  Email = "EMAIL",
  FirstName = "FIRST_NAME",
  LastName = "LAST_NAME",
  PhoneNumber = "PHONE_NUMBER",
  Referrer = "REFERRER",
}

export type ListProsSort = {
  ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
  by: ListProsSortBy;
};

export enum ListProsSortBy {
  CreatedAt = "CREATED_AT",
  FirstName = "FIRST_NAME",
  IdentityVerificationSubmittedAt = "IDENTITY_VERIFICATION_SUBMITTED_AT",
  LastName = "LAST_NAME",
}

export enum ListProsTestStatus {
  AwaitingResult = "AWAITING_RESULT",
  Failed = "FAILED",
  NotStarted = "NOT_STARTED",
  NotTaken = "NOT_TAKEN",
  Passed = "PASSED",
  Scheduled = "SCHEDULED",
}

export type ListRefundRequestsInput = {
  order?: InputMaybe<Scalars["String"]["input"]>;
};

export type ListTradesFilters = {
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
};

export type LocationDataInput = {
  address: Scalars["String"]["input"];
  city: Scalars["String"]["input"];
  coordinates?: InputMaybe<LatLongInput>;
  placeId: Scalars["String"]["input"];
  state: Scalars["String"]["input"];
};

export enum LogBookReportingFrequency {
  Daily = "DAILY",
  Weekly = "WEEKLY",
}

export type LogEventContextFieldArgs = {
  key: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export enum MaintenanceFrequency {
  Biweekly = "BIWEEKLY",
  Daily = "DAILY",
  Monthly = "MONTHLY",
  Quarterly = "QUARTERLY",
  Weekly = "WEEKLY",
  Yearly = "YEARLY",
}

export enum MaintenancePlanType {
  OneOff = "ONE_OFF",
  Routine = "ROUTINE",
}

export type MarkOrganizationToolAsPaidDetails = {
  amount: Scalars["Float"]["input"];
  paymentMethod: OrganizationToolPaymentMethod;
  paymentNotes?: InputMaybe<Scalars["String"]["input"]>;
  paymentReference: Scalars["String"]["input"];
};

export enum MarketingCampaign {
  Fixme = "FIXME",
}

export enum MarketplaceJobShortlistStatus {
  Accepted = "ACCEPTED",
  Declined = "DECLINED",
  Pending = "PENDING",
}

export enum MeansOfIdentification {
  Bvn = "BVN",
  DriversLicense = "DRIVERS_LICENSE",
  Nin = "NIN",
  Passport = "PASSPORT",
  VotersCard = "VOTERS_CARD",
}

export type MonthYearInput = {
  month: Scalars["Float"]["input"];
  year: Scalars["Float"]["input"];
};

export enum NotificationEvent {
  InvoicePaid = "INVOICE_PAID",
  InvoiceRaised = "INVOICE_RAISED",
  ProDispatched = "PRO_DISPATCHED",
  RecruitmentRequested = "RECRUITMENT_REQUESTED",
  SubscriptionRequested = "SUBSCRIPTION_REQUESTED",
}

export type OnDemandServiceRequestInput = {
  address: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  services: Array<Scalars["String"]["input"]>;
  visitDate: Scalars["DateTimeISO"]["input"];
};

export type OrderCartItem = {
  custom?: InputMaybe<JobCustomTaskInput>;
  locationId?: InputMaybe<Scalars["String"]["input"]>;
  task?: InputMaybe<JobTaskInput>;
};

export type OrderFilterInput = {
  condition: Array<Scalars["String"]["input"]>;
  type: OrderFilterType;
};

export enum OrderFilterType {
  Assigned = "ASSIGNED",
  Completed = "COMPLETED",
  CreatedBetween = "CREATED_BETWEEN",
  Pending = "PENDING",
  Unassigned = "UNASSIGNED",
}

export enum OrderHandlingQuotationStatus {
  Accepted = "ACCEPTED",
  Cancelled = "CANCELLED",
  Declined = "DECLINED",
  Pending = "PENDING",
}

export type OrderSearchInput = {
  query: Scalars["String"]["input"];
  type: OrderSearchType;
};

export enum OrderSearchType {
  ClientName = "CLIENT_NAME",
  OrderCode = "ORDER_CODE",
}

export type OrderSortInput = {
  ascending: Scalars["Boolean"]["input"];
  type: OrderSortType;
};

export enum OrderSortType {
  ClientName = "CLIENT_NAME",
  OrderCode = "ORDER_CODE",
}

export enum OrderStatus {
  Cancelled = "CANCELLED",
  Completed = "COMPLETED",
  InProgress = "IN_PROGRESS",
  Processing = "PROCESSING",
}

export type OrganizationInfoInput = {
  industry?: InputMaybe<Scalars["String"]["input"]>;
  organization: Scalars["String"]["input"];
  roleInOrganization: Scalars["String"]["input"];
};

export type OrganizationPlanSpecQuotaInput = {
  limit: Scalars["Int"]["input"];
  type: OrganizationPlanSpecQuotaType;
};

export enum OrganizationPlanSpecQuotaType {
  Concurrent = "CONCURRENT",
  Persistent = "PERSISTENT",
  Recurring = "RECURRING",
}

export type OrganizationPlanSpecQuotasInput = {
  activeAdverts: OrganizationPlanSpecQuotaInput;
  adminSeats: OrganizationPlanSpecQuotaInput;
  communityMembers: OrganizationPlanSpecQuotaInput;
  connections: OrganizationPlanSpecQuotaInput;
};

export type OrganizationSharingInput = {
  adminEmail?: InputMaybe<Scalars["String"]["input"]>;
  countryCode?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  organizationName?: InputMaybe<Scalars["String"]["input"]>;
};

export enum OrganizationTalentPoolInstanceStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
  Completed = "COMPLETED",
}

export enum OrganizationTalentPoolStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
}

export enum OrganizationToolPaymentMethod {
  BankTransfer = "BANK_TRANSFER",
  Online = "ONLINE",
}

/** Status of the organization user invite */
export enum OrganizationUserInviteStatus {
  Accepted = "ACCEPTED",
  Cancelled = "CANCELLED",
  Pending = "PENDING",
}

/** Role of the user in the organization */
export enum OrganizationUserRole {
  Admin = "ADMIN",
  Member = "MEMBER",
}

export type OtherServiceRequestInput = {
  comments?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
};

export type OutreachSourceInput = {
  name?: InputMaybe<Scalars["String"]["input"]>;
  type: Scalars["String"]["input"];
};

export enum PaymentMethod {
  ByOutput = "BY_OUTPUT",
  FixedAmount = "FIXED_AMOUNT",
}

export enum PaymentProviderChannel {
  Offline = "OFFLINE",
  Online = "ONLINE",
}

export enum PaymentSchedule {
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
  Yearly = "YEARLY",
}

export enum PhoneType {
  BasicPhone = "BASIC_PHONE",
  NoPhone = "NO_PHONE",
  Smartphone = "SMARTPHONE",
}

export type PointChange = {
  change: Scalars["Float"]["input"];
  tradesmanId: Scalars["String"]["input"];
};

/** Filter for portfolio completion status */
export enum PortfolioCompletionFilter {
  All = "ALL",
  Complete = "COMPLETE",
  Incomplete = "INCOMPLETE",
}

export type PreferencesInput = {
  hasDisabledTelegramPopUp?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ProAccountType {
  FullyProvisioned = "FULLY_PROVISIONED",
  WhatsappGenerated = "WHATSAPP_GENERATED",
}

export type ProApplicationIdentificationInput = {
  identificationNumber: Scalars["String"]["input"];
  identificationUrl: Scalars["String"]["input"];
  meansOfIdentification: MeansOfIdentification;
};

export type ProAssignmentChecklistInput = {
  onLaborHackApparel: Scalars["Boolean"]["input"];
  onProtectiveGear: Scalars["Boolean"]["input"];
  validationImageUrl: Scalars["String"]["input"];
  withProperEquipment: Scalars["Boolean"]["input"];
};

export type ProLocation = {
  area?: InputMaybe<Scalars["String"]["input"]>;
  buildingNumber?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  landmark?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  streetName?: InputMaybe<Scalars["String"]["input"]>;
};

export enum ProPortfolioBadgeStatus {
  Completed = "COMPLETED",
  Declined = "DECLINED",
  NotStarted = "NOT_STARTED",
  Pending = "PENDING",
}

export enum ProRecruitmentContractStatus {
  Active = "ACTIVE",
  Pending = "PENDING",
  Terminated = "TERMINATED",
}

export enum ProTrack {
  Localgig = "LOCALGIG",
  Studywork = "STUDYWORK",
}

export enum ProTradeLevelDiscountType {
  Basic = "BASIC",
  Retry = "RETRY",
}

export enum ProTradeRequirementInterviewEventStatus {
  Cancelled = "CANCELLED",
  Completed = "COMPLETED",
  Rescheduled = "RESCHEDULED",
  Scheduled = "SCHEDULED",
}

export enum Progress {
  Assigned = "ASSIGNED",
  ClientInspection = "CLIENT_INSPECTION",
  Completed = "COMPLETED",
  FinalQuote = "FINAL_QUOTE",
  MaterialsPurchased = "MATERIALS_PURCHASED",
  NotStarted = "NOT_STARTED",
  PreInspection = "PRE_INSPECTION",
  UnAssigned = "UN_ASSIGNED",
}

export enum ProjectChallenges {
  BudgetOverruns = "BUDGET_OVERRUNS",
  DelaysInDelivery = "DELAYS_IN_DELIVERY",
  PoorCommunication = "POOR_COMMUNICATION",
  PoorQualityWork = "POOR_QUALITY_WORK",
  UnverifiedSkillsOrQualifications = "UNVERIFIED_SKILLS_OR_QUALIFICATIONS",
}

export type ProjectOutsourcingDto = {
  challengesToAvoid: Array<ProjectChallenges>;
  description: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  expectedTeamSize: Scalars["Float"]["input"];
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  industry?: InputMaybe<Scalars["String"]["input"]>;
  keySkillsRequired: Scalars["String"]["input"];
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  managementType: Scalars["String"]["input"];
  organization?: InputMaybe<Scalars["String"]["input"]>;
  otherProjectChallenges?: InputMaybe<Scalars["String"]["input"]>;
  phone: Scalars["String"]["input"];
  projectType: Scalars["String"]["input"];
  roleInOrganization?: InputMaybe<Scalars["String"]["input"]>;
  userType: Scalars["String"]["input"];
};

export type ProposedContractInfo = {
  contractInterval: ContractInterval;
  contractLength: Scalars["Float"]["input"];
  contractStartDate: Scalars["DateTimeISO"]["input"];
  nonBillableDates: Array<Scalars["String"]["input"]>;
  nonWorkingDays: Array<Scalars["String"]["input"]>;
};

export type ProposedSchedule = {
  end: Scalars["DateTimeISO"]["input"];
  nonBillableDates?: InputMaybe<Array<Scalars["String"]["input"]>>;
  nonWorkingDays?: InputMaybe<Array<Scalars["String"]["input"]>>;
  overtimeDates?: InputMaybe<Array<Scalars["DateTimeISO"]["input"]>>;
  start: Scalars["DateTimeISO"]["input"];
};

export enum QuotationStatus {
  Approved = "APPROVED",
  AwaitingApproval = "AWAITING_APPROVAL",
  Cancelled = "CANCELLED",
  NotSent = "NOT_SENT",
}

export type RecruitToolSalesConversationRequestDto = {
  digitalToolsUsed?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  majorChallenges: Scalars["String"]["input"];
  organization: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
  preferredSalesConversationDate: Scalars["DateTimeISO"]["input"];
  preferredSalesConversationTime: Scalars["String"]["input"];
  roleInOrganization: Scalars["String"]["input"];
  typeOfTalent: Scalars["String"]["input"];
};

export type RecruitmentConsultationDto = {
  companySize: CompanySize;
  duration: DurationDetailsInput;
  email: Scalars["String"]["input"];
  employmentType: Scalars["String"]["input"];
  expectedStartDate: Scalars["DateTimeISO"]["input"];
  industry: Scalars["String"]["input"];
  jobTitle: Scalars["String"]["input"];
  location: Scalars["String"]["input"];
  organization: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
  roleInOrganization: Scalars["String"]["input"];
  salaryRange: Scalars["String"]["input"];
};

export enum RecruitmentJobShortlistStatus {
  Accepted = "ACCEPTED",
  Declined = "DECLINED",
  Pending = "PENDING",
}

export type RecruitmentPayrollPeriodInput = {
  end: Scalars["DateTimeISO"]["input"];
  start: Scalars["DateTimeISO"]["input"];
};

export type RecruitmentRequestInput = {
  _id?: InputMaybe<Scalars["String"]["input"]>;
  categoryId: Scalars["String"]["input"];
  contractDetails?: InputMaybe<ContractDetailsInput>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  nonWorkingDays?: InputMaybe<Array<Scalars["String"]["input"]>>;
  proCount: Scalars["Float"]["input"];
  proLevel: Scalars["Float"]["input"];
  proposedStartDate: Scalars["DateTimeISO"]["input"];
};

export enum RecruitmentRequestStatus {
  Assigning = "ASSIGNING",
  Fulfilled = "FULFILLED",
  Pending = "PENDING",
  QuotationSent = "QUOTATION_SENT",
}

export enum RecruitmentType {
  Contract = "CONTRACT",
  FullTime = "FULL_TIME",
}

export type RefereeInput = {
  companyAddress: Scalars["String"]["input"];
  companyName: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  jobTitle: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  relationship: Scalars["String"]["input"];
};

export type ReferrerInput = {
  businessName: Scalars["String"]["input"];
  commissionPercentage: Scalars["Float"]["input"];
  email: Scalars["String"]["input"];
  linkedDiscountCode: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  referralCode: Scalars["String"]["input"];
};

export type ReferrerPayoutOverrideInput = {
  amount?: InputMaybe<Scalars["Float"]["input"]>;
  reason: Scalars["String"]["input"];
};

export type RegisterBusinessInput = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  clients?: InputMaybe<Array<CreateBusinessClientInput>>;
  email: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
};

export type RegisterNewClientInput = {
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  leadSource: LeadSource;
  marketingTag?: InputMaybe<Scalars["String"]["input"]>;
  otherLeadSourceText?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  referralCode?: InputMaybe<Scalars["String"]["input"]>;
};

export enum RemittanceInterval {
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
}

export enum RenovationArea {
  BathroomRemodeling = "BATHROOM_REMODELING",
  Carpentry = "CARPENTRY",
  Electrical = "ELECTRICAL",
  FlooringTiling = "FLOORING_TILING",
  KitchenRemodeling = "KITCHEN_REMODELING",
  Other = "OTHER",
  Painting = "PAINTING",
  Plumbing = "PLUMBING",
  Roofing = "ROOFING",
  WindowsDoors = "WINDOWS_DOORS",
}

export type RenovationProjectRequestDto = {
  areas: Array<RenovationArea>;
  contactInfo: ContactInfoInput;
  intendedDuration: SimpleDuration;
  organizationInfo?: InputMaybe<OrganizationInfoInput>;
  otherArea?: InputMaybe<Scalars["String"]["input"]>;
  projectLocation: Scalars["String"]["input"];
  requiresStructuralChanges: Scalars["Boolean"]["input"];
};

export enum Role {
  Bot = "BOT",
  BusinessDeveloper = "BUSINESS_DEVELOPER",
  CertificationAdministrator = "CERTIFICATION_ADMINISTRATOR",
  Client = "CLIENT",
  Customerservice = "CUSTOMERSERVICE",
  Employer = "EMPLOYER",
  Finance = "FINANCE",
  Outreach = "OUTREACH",
  Pro = "PRO",
  Projectmanager = "PROJECTMANAGER",
  ProAdministrator = "PRO_ADMINISTRATOR",
  RecruitmentAdministrator = "RECRUITMENT_ADMINISTRATOR",
  Root = "ROOT",
  SystemAdministrator = "SYSTEM_ADMINISTRATOR",
  Tradesman = "TRADESMAN",
  TrainingCommunityAdmin = "TRAINING_COMMUNITY_ADMIN",
  UserAdministrator = "USER_ADMINISTRATOR",
}

export enum SmsLedgerEntryType {
  Credit = "CREDIT",
  Debit = "DEBIT",
}

export enum SmsLedgerTransactionType {
  Payg = "PAYG",
  Subscription = "SUBSCRIPTION",
  Usage = "USAGE",
}

export type SalaryDetailsInput = {
  cap?: InputMaybe<Scalars["Float"]["input"]>;
  currency: Scalars["String"]["input"];
  currencyCode: Scalars["String"]["input"];
  starting: Scalars["Float"]["input"];
};

export type SaveBusinessClientInput = {
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type SaveBusinessInput = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  clients?: InputMaybe<Array<SaveBusinessClientInput>>;
  name: Scalars["String"]["input"];
  state?: InputMaybe<Scalars["String"]["input"]>;
};

export enum ScheduleConflictType {
  AssignmentScheduled = "ASSIGNMENT_SCHEDULED",
  ContractOverlap = "CONTRACT_OVERLAP",
  MarketplaceMatch = "MARKETPLACE_MATCH",
}

export enum SentEmailDeliveryStatus {
  Delivered = "Delivered",
  Failed = "Failed",
  Opened = "Opened",
  Pending = "Pending",
}

export type ShadowUserPayload = {
  email: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  partnerCountryCode?: InputMaybe<Scalars["String"]["input"]>;
  partnerName?: InputMaybe<Scalars["String"]["input"]>;
  partnershipId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ShareOrganizationTalentPoolDto = {
  expiresAt: Scalars["DateTimeISO"]["input"];
  masterPoolId: Scalars["String"]["input"];
  organizationDetails: OrganizationSharingInput;
};

export enum SimpleDuration {
  Gt_6Months = "GT_6_MONTHS",
  Lt_1Month = "LT_1_MONTH",
  OneToThreeMonths = "ONE_TO_THREE_MONTHS",
  ThreeToSixMonths = "THREE_TO_SIX_MONTHS",
}

export type StartBillingForRecruitmentInput = {
  id: Scalars["String"]["input"];
  options: StartBillingForRecruitmentOptions;
};

export type StartBillingForRecruitmentOptions = {
  billingAddressId: Scalars["String"]["input"];
  payBeforeService: Scalars["Boolean"]["input"];
};

export enum Status {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
  Paused = "PAUSED",
}

export enum StudyWorkOpportunityCountry {
  Canada = "CANADA",
}

export type SubCategoryInput = {
  category: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  imageUrl?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  requestCount?: Scalars["Float"]["input"];
};

export type SubmitIdentityInformationInput = {
  dateOfBirth?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  identificationNumber: Scalars["String"]["input"];
  /** Base64 encoded photo of the user's ID */
  identityImage?: InputMaybe<Scalars["String"]["input"]>;
  /** URL of the user's ID image */
  identityImageUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** Base64 encoded photos of the user's face for a liveness check */
  livenessImages?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Base64 encoded photo of the user */
  selfieImage?: InputMaybe<Scalars["String"]["input"]>;
  type: MeansOfIdentification;
};

export type SubmitProApplicationInput = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  averageMonthlyIncome?: InputMaybe<Scalars["Float"]["input"]>;
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
  channel?: InputMaybe<Scalars["String"]["input"]>;
  channelOutreachSourceId?: InputMaybe<Scalars["String"]["input"]>;
  country: Scalars["String"]["input"];
  currentIndustry?: InputMaybe<Industry>;
  dateOfBirth: Scalars["DateTimeISO"]["input"];
  detailedAddress?: InputMaybe<AddressInput>;
  email: Scalars["String"]["input"];
  employmentStatus?: InputMaybe<EmploymentStatus>;
  firstName: Scalars["String"]["input"];
  gender: Gender;
  highestEducationLevel?: InputMaybe<EducationLevel>;
  identification?: InputMaybe<ProApplicationIdentificationInput>;
  incomeCurrency?: InputMaybe<Scalars["String"]["input"]>;
  incomeLevel?: InputMaybe<IncomeLevel>;
  jobTitle?: InputMaybe<Scalars["String"]["input"]>;
  lastName: Scalars["String"]["input"];
  leadSource: Scalars["String"]["input"];
  leadSourceText?: InputMaybe<Scalars["String"]["input"]>;
  locationOutreachSourceId?: InputMaybe<Scalars["String"]["input"]>;
  numberOfDaysWorkedPerWeek?: InputMaybe<Scalars["Float"]["input"]>;
  otherCategoryText?: InputMaybe<Scalars["String"]["input"]>;
  otherRelevantDocumentUrls?: InputMaybe<Array<Scalars["String"]["input"]>>;
  phoneNumber: Scalars["String"]["input"];
  phoneType?: InputMaybe<PhoneType>;
  profilePictureUrl?: InputMaybe<Scalars["String"]["input"]>;
  reasonForJoiningLaborHack?: InputMaybe<Scalars["String"]["input"]>;
  reasonForJoiningLaborHackOtherText?: InputMaybe<Scalars["String"]["input"]>;
  referredBy?: InputMaybe<Scalars["String"]["input"]>;
  resumeUrl?: InputMaybe<Scalars["String"]["input"]>;
  stateOfResidence?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  trainingType?: InputMaybe<TrainingType>;
  userAddedTags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  yearsOfExperience?: InputMaybe<Scalars["Float"]["input"]>;
};

export enum SubscriptionInterval {
  Biannually = "BIANNUALLY",
  Monthly = "MONTHLY",
  Quarterly = "QUARTERLY",
  Yearly = "YEARLY",
}

export type SubscriptionRequestCallPayoutOverrideInput = {
  amount?: InputMaybe<Scalars["Float"]["input"]>;
  reason: Scalars["String"]["input"];
};

export type SystemAdminCreateOrganizationTalentPoolDto = {
  communityMemberEmails: Array<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  impersonatedOrganizationUserId: Scalars["String"]["input"];
  organizationId: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
};

export type SystemAdminShareOrganizationTalentPoolDto = {
  expiresAt: Scalars["DateTimeISO"]["input"];
  impersonatedOrganizationUserId: Scalars["String"]["input"];
  masterPoolId: Scalars["String"]["input"];
  organizationDetails: Array<OrganizationSharingInput>;
};

export enum TalentPoolCandidateStatus {
  Hired = "HIRED",
  Interview = "INTERVIEW",
  Recommended = "RECOMMENDED",
  Rejected = "REJECTED",
  Shortlisted = "SHORTLISTED",
}

export type TalentPoolHiringTermsInput = {
  contractLength?: InputMaybe<Scalars["Int"]["input"]>;
  contractUnit?: InputMaybe<EmploymentContractUnit>;
  employmentType: EmploymentType;
  salary?: InputMaybe<Scalars["Float"]["input"]>;
  salaryUnit?: InputMaybe<EmploymentSalaryUnit>;
  startDate?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  title: Scalars["String"]["input"];
};

export type ThirdPartyDetailsInput = {
  createThirdParty?: InputMaybe<CreateThirdPartyInput>;
  thirdPartyId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ThirdPartyIntegratorPayoutOverrideInput = {
  amount: Scalars["Float"]["input"];
  reason: Scalars["String"]["input"];
};

export enum TradeRequirementActionTypes {
  OpenUrl = "OPEN_URL",
}

export enum TradeRequirementClass {
  AlternativeToPractical = "ALTERNATIVE_TO_PRACTICAL",
  PriorLearning = "PRIOR_LEARNING",
  SoftSkills = "SOFT_SKILLS",
}

export enum TradeRequirementType {
  ExternalAssessment = "EXTERNAL_ASSESSMENT",
  InternalAssessment = "INTERNAL_ASSESSMENT",
  Interview = "INTERVIEW",
}

export type TradesmanLocation = {
  area?: InputMaybe<Scalars["String"]["input"]>;
  buildingNumber?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  landmark?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  streetName?: InputMaybe<Scalars["String"]["input"]>;
};

export enum TrainingCommunityMemberStatus {
  NotRegistered = "NOT_REGISTERED",
  Registered = "REGISTERED",
  SetupCompleted = "SETUP_COMPLETED",
}

export type TrainingCommunityProgramLogBookEntryInput = {
  date: Scalars["String"]["input"];
  tasks: Array<TrainingCommunityProgramLogBookEntryTaskInput>;
};

export type TrainingCommunityProgramLogBookEntryTaskInput = {
  description: Scalars["String"]["input"];
  media?: InputMaybe<
    Array<TrainingCommunityProgramStudentLogBookEntryTaskMediaItemInput>
  >;
};

export type TrainingCommunityProgramStudentLogBookEntryTaskMediaItemInput = {
  key: Scalars["String"]["input"];
  mimeType: Scalars["String"]["input"];
};

export enum TrainingType {
  Apprentice = "APPRENTICE",
  College = "COLLEGE",
  Other = "OTHER",
  Polytechnic = "POLYTECHNIC",
  TrainingInstitute = "TRAINING_INSTITUTE",
}

export enum TransactionStatus {
  Failure = "FAILURE",
  Pending = "PENDING",
  Success = "SUCCESS",
}

export enum TransferStatus {
  AwaitingApproval = "AWAITING_APPROVAL",
  Confirmed = "CONFIRMED",
  Failed = "FAILED",
  Pending = "PENDING",
  Queued = "QUEUED",
  Reversed = "REVERSED",
}

export enum TransferTypes {
  ContractorPayment = "CONTRACTOR_PAYMENT",
  Handling = "HANDLING",
  ReferrerPayout = "REFERRER_PAYOUT",
  Refund = "REFUND",
  SubscriptionScheduledRequestPayout = "SUBSCRIPTION_SCHEDULED_REQUEST_PAYOUT",
  ThirdPartyIntegratorPayout = "THIRD_PARTY_INTEGRATOR_PAYOUT",
}

export type UpdateAssignmentPaymentInput = {
  amount: Scalars["Float"]["input"];
  assignmentPaymentId: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  proId: Scalars["String"]["input"];
};

export type UpdateCandidateStatusDto = {
  candidateId: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  rejectionReason?: InputMaybe<Scalars["String"]["input"]>;
  status: TalentPoolCandidateStatus;
};

export type UpdateCertificationInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateCommunityAnnouncementInput = {
  communicationChannels?: InputMaybe<Array<CommunicationChannel>>;
  publishedAt?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  status?: InputMaybe<CommunityAnnouncementStatus>;
  targetSegmentIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<CommunityAnnouncementType>;
};

export type UpdateCommunityJobOpportunityInput = {
  applicationDeadline?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  duration?: InputMaybe<DurationDetailsInput>;
  employmentType?: InputMaybe<EmploymentType>;
  location?: InputMaybe<JobLocationInput>;
  salary?: InputMaybe<SalaryDetailsInput>;
  tagIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateCommunitySegmentInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  memberIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateContractQuotationItemsInput = {
  id: Scalars["String"]["input"];
  items: Array<ContractQuotationItemInput>;
};

export type UpdateContractRecruitmentInput = {
  clientId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  recruitmentDiscountValue?: InputMaybe<Scalars["Float"]["input"]>;
  requests?: InputMaybe<Array<RecruitmentRequestInput>>;
  status?: InputMaybe<RecruitmentRequestStatus>;
};

export type UpdateJobFinalCostInput = {
  finalCost: Scalars["Int"]["input"];
  jobId: Scalars["String"]["input"];
};

export type UpdateJobsInvoiceDetailsInput = {
  items: Array<JobInvoiceDetailsItem>;
};

export type UpdateMaterialsInvoiceInput = {
  allowedPaymentProviders?: InputMaybe<Array<Scalars["String"]["input"]>>;
  invoiceId: Scalars["String"]["input"];
  jobUpdates: Array<JobInvoiceDetailsItem>;
  splits?: InputMaybe<Array<Scalars["Float"]["input"]>>;
};

export type UpdateProRecruitmentContractInput = {
  agreedRate?: InputMaybe<Scalars["Float"]["input"]>;
  endDate?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  id: Scalars["String"]["input"];
  potentialMonthlyGrossSalary?: InputMaybe<Scalars["Float"]["input"]>;
  proLevel?: InputMaybe<Scalars["Int"]["input"]>;
  recruitmentType?: InputMaybe<RecruitmentType>;
  requestedStartDate?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  status?: InputMaybe<ProRecruitmentContractStatus>;
  terminatedAt?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
};

export type UpdateTradeInput = {
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
  certificationId?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateTrainingCommunityProgramInput = {
  enableLogBookReporting?: InputMaybe<Scalars["Boolean"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  invitedSupervisorEmails?: InputMaybe<Array<Scalars["String"]["input"]>>;
  logBookReportingFrequency?: InputMaybe<LogBookReportingFrequency>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  supervisorIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export enum UserType {
  Pro = "PRO",
}

export enum VisitReason {
  Inspection = "INSPECTION",
  Work = "WORK",
}

export enum VisitStatus {
  Arrived = "ARRIVED",
  Cancelled = "CANCELLED",
  Scheduled = "SCHEDULED",
}

export type CreateCategoryInput = {
  imageUrl?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  proTitle?: InputMaybe<Scalars["String"]["input"]>;
  requestCount?: InputMaybe<Scalars["Float"]["input"]>;
};

export type CreateTaskInput = {
  category: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  estimatedCost: Scalars["Float"]["input"];
  imageUrl: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  subCategory: Scalars["String"]["input"];
};

/** Input type to edit category */
export type EditCategoryInput = {
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
  imageUrl?: InputMaybe<Scalars["String"]["input"]>;
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  proTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type GetUserProfilesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserProfilesQuery = {
  __typename?: "Query";
  myPro?: { __typename?: "Pro"; id: string } | null;
  myClient?: { __typename?: "Client"; id: string } | null;
};

export type FinalizeHomeownerRequestMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type FinalizeHomeownerRequestMutation = {
  __typename?: "Mutation";
  finalizeHomeownerRequest: {
    __typename?: "HomeownerRequest";
    id: string;
    isComplete: boolean;
  };
};

export type HomeownerFieldsFragment = {
  __typename?: "HomeownerRequest";
  id: string;
  otherCategoryText?: string | null;
  description?: string | null;
  email?: string | null;
  frequency?: HomeownerRequestTaskFrequency | null;
  startDate?: any | null;
  firstName?: string | null;
  lastName?: string | null;
  isPaid?: boolean | null;
  phoneNumber?: string | null;
  isComplete: boolean;
  category?: { __typename?: "Category"; id: string; name: string } | null;
  client?: {
    __typename?: "Client";
    id: string;
    email: string;
    addresses?: Array<{
      __typename?: "Address";
      id: string;
      address: string;
      city: string;
      state: string;
    }> | null;
  } | null;
  plan?: {
    __typename?: "CategorySubscriptionPackagePlan";
    id: string;
    interval: SubscriptionInterval;
    package: {
      __typename?: "CategorySubscriptionPackage";
      id: string;
      name: string;
    };
  } | null;
  invoice?: {
    __typename?: "Invoice";
    id: string;
    appliedDiscount?: {
      __typename?: "InvoiceDiscount";
      id: string;
      code: string;
      value: number;
    } | null;
  } | null;
  address?: {
    __typename?: "Address";
    id: string;
    address: string;
    formattedAddress: string;
    city: string;
    state: string;
    placeId?: string | null;
  } | null;
} & { " $fragmentName"?: "HomeownerFieldsFragment" };

export type GetHomeownerRequestQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetHomeownerRequestQuery = {
  __typename?: "Query";
  homeownerRequest: { __typename?: "HomeownerRequest" } & {
    " $fragmentRefs"?: { HomeownerFieldsFragment: HomeownerFieldsFragment };
  };
};

export type UpdateHomeownerRequestMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  category?: InputMaybe<Scalars["String"]["input"]>;
  otherCategoryText?: InputMaybe<Scalars["String"]["input"]>;
  plan?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  address?: InputMaybe<AddressInput>;
  addressId?: InputMaybe<Scalars["String"]["input"]>;
  frequency?: InputMaybe<HomeownerRequestTaskFrequency>;
  startDate?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  leadSource?: InputMaybe<Scalars["String"]["input"]>;
  otherLeadSourceText?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateHomeownerRequestMutation = {
  __typename?: "Mutation";
  updateHomeownerRequest: { __typename?: "HomeownerRequest" } & {
    " $fragmentRefs"?: { HomeownerFieldsFragment: HomeownerFieldsFragment };
  };
};

export type CreateCommunityManagementDemoRequestTaskMutationVariables = Exact<{
  communityManagementDemoRequestDto: CommunityManagementDemoRequestDto;
}>;

export type CreateCommunityManagementDemoRequestTaskMutation = {
  __typename?: "Mutation";
  createCommunityManagementDemoRequestTask: string;
};

export type CreateCommunityManagementSalesConversationTaskMutationVariables =
  Exact<{
    communityManagementSalesConversationRequestDto: CommunityManagementSalesConversationRequestDto;
  }>;

export type CreateCommunityManagementSalesConversationTaskMutation = {
  __typename?: "Mutation";
  createCommunityManagementSalesConversationTask: string;
};

export type ClientExistQueryVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type ClientExistQuery = { __typename?: "Query"; clientExists: boolean };

export type CreateHomeownerRequestMutationVariables = Exact<{
  categoryId: Scalars["String"]["input"];
  otherCategoryText?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  planId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CreateHomeownerRequestMutation = {
  __typename?: "Mutation";
  createHomeownerRequest: { __typename?: "HomeownerRequest"; id: string };
};

export type LogOutOfLagosHomeownerRequestAttemptMutationVariables = Exact<{
  state: Scalars["String"]["input"];
  city: Scalars["String"]["input"];
  address: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  homeownerRequestId: Scalars["String"]["input"];
}>;

export type LogOutOfLagosHomeownerRequestAttemptMutation = {
  __typename?: "Mutation";
  logOutOfLagosHomeownerRequestAttempt: boolean;
};

export type CreateCustomSubscriptionRequestMutationVariables = Exact<{
  name: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  accountType: CustomSubscriptionRequestAccountType;
  duration: Scalars["String"]["input"];
  specificRequirements: Scalars["String"]["input"];
  categoryId: Scalars["String"]["input"];
}>;

export type CreateCustomSubscriptionRequestMutation = {
  __typename?: "Mutation";
  createCustomSubscriptionRequest: boolean;
};

export type StartHomeownerRequestPaymentMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  discountCode?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type StartHomeownerRequestPaymentMutation = {
  __typename?: "Mutation";
  startHomeownerRequestPayment: {
    __typename?: "HomeownerRequest";
    id: string;
    isPaid?: boolean | null;
    invoice?: {
      __typename?: "Invoice";
      id: string;
      appliedDiscount?: {
        __typename?: "InvoiceDiscount";
        id: string;
        code: string;
        value: number;
      } | null;
    } | null;
  };
};

export type CategorySubscriptionPackagePlanQueryVariables = Exact<{
  id: Scalars["String"]["input"];
  discount?: InputMaybe<CategorySubscriptionPackagePlanCostBreakdownDiscountOptions>;
}>;

export type CategorySubscriptionPackagePlanQuery = {
  __typename?: "Query";
  categorySubscriptionPackagePlan: {
    __typename?: "CategorySubscriptionPackagePlan";
    id: string;
    package: {
      __typename?: "CategorySubscriptionPackage";
      id: string;
      name: string;
    };
    costBreakdown: {
      __typename?: "CategorySubscriptionPackagePlanCostBreakdown";
      subTotal: number;
      discount: number;
      tax: number;
      total: number;
      transactionFee?: number | null;
    };
  };
};

export type AvailableAutoAppliedInvoiceDiscountQueryVariables = Exact<{
  invoiceType?: InputMaybe<InvoiceType>;
}>;

export type AvailableAutoAppliedInvoiceDiscountQuery = {
  __typename?: "Query";
  availableAutoAppliedInvoiceDiscount?: {
    __typename?: "InvoiceDiscount";
    id: string;
    code: string;
    value: number;
    valueCap?: number | null;
    balance?: number | null;
  } | null;
};

export type ConfirmHomeownerRequestPaymentMutationVariables = Exact<{
  homeownerRequestId: Scalars["String"]["input"];
  transactionReference: Scalars["String"]["input"];
}>;

export type ConfirmHomeownerRequestPaymentMutation = {
  __typename?: "Mutation";
  confirmHomeownerRequestPayment: {
    __typename?: "HomeownerRequest";
    id: string;
    isPaid?: boolean | null;
    firstName?: string | null;
    email?: string | null;
    plan?: {
      __typename?: "CategorySubscriptionPackagePlan";
      id: string;
    } | null;
  };
};

export type GetInvoiceDiscountByCodeQueryVariables = Exact<{
  code: Scalars["String"]["input"];
}>;

export type GetInvoiceDiscountByCodeQuery = {
  __typename?: "Query";
  invoiceDiscountByCode?: {
    __typename?: "InvoiceDiscount";
    id: string;
    code: string;
    description: string;
    value: number;
    balance?: number | null;
  } | null;
};

export type CanApplyDiscountQueryVariables = Exact<{
  code: Scalars["String"]["input"];
  invoiceType?: InputMaybe<InvoiceType>;
}>;

export type CanApplyDiscountQuery = {
  __typename?: "Query";
  canApplyInvoiceDiscount: boolean;
};

export type GetShareableApplicationQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetShareableApplicationQuery = {
  __typename?: "Query";
  getShareableApplication?: {
    __typename?: "ShareableApplication";
    status: string;
    createdAt?: any | null;
    updatedAt?: any | null;
    applicant: {
      __typename?: "CensoredApplicant";
      firstName: string;
      lastName: string;
      email: string;
      phoneNumber: string;
      jobTitle: string;
      yearsOfExperience?: number | null;
    };
    education: Array<{
      __typename?: "JobApplicationEducation";
      id?: string | null;
      schoolName: string;
      fieldOfStudy?: string | null;
      qualification: EducationLevel;
      createdAt: any;
    }>;
    employmentHistory: Array<{
      __typename?: "JobApplicationEmploymentHistoryItem";
      id: string;
      companyName: string;
      jobTitle: string;
      description: string;
      startedAt: any;
      endedAt?: any | null;
      createdAt: any;
      media: Array<{
        __typename?: "JobApplicationMediaItem";
        key: string;
        mimeType: string;
        originalUrl: string;
        thumbnailUrl: string;
      }>;
    }>;
    projectHistory: Array<{
      __typename?: "JobApplicationProjectHistoryItem";
      id?: string | null;
      name: string;
      description: string;
      startedAt?: any | null;
      endedAt: any;
      videos: Array<string>;
      createdAt: any;
      media: Array<{
        __typename?: "JobApplicationMediaItem";
        key: string;
        mimeType: string;
        originalUrl: string;
        thumbnailUrl: string;
      }>;
    }>;
    certifications: Array<{
      __typename?: "JobApplicationCertification";
      id?: string | null;
      name: string;
      issuedBy: string;
      issuedAt: any;
      issuerCertificationId?: string | null;
      url?: string | null;
      createdAt: any;
    }>;
  } | null;
};

export type MyJobApplicationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Float"]["input"]>;
}>;

export type MyJobApplicationsQuery = {
  __typename?: "Query";
  myJobApplications: Array<{
    __typename?: "EmployerJobApplication";
    id: string;
    createdAt: any;
    education: Array<{
      __typename?: "JobApplicationEducation";
      id?: string | null;
      schoolName: string;
      fieldOfStudy?: string | null;
      qualification: EducationLevel;
      createdAt: any;
    }>;
    employmentHistory: Array<{
      __typename?: "JobApplicationEmploymentHistoryItem";
      id: string;
      companyName: string;
      jobTitle: string;
      description: string;
      startedAt: any;
      endedAt?: any | null;
      createdAt: any;
      media: Array<{
        __typename?: "JobApplicationMediaItem";
        key: string;
        mimeType: string;
        originalUrl: string;
        thumbnailUrl: string;
      }>;
    }>;
    projectHistory: Array<{
      __typename?: "JobApplicationProjectHistoryItem";
      id?: string | null;
      name: string;
      description: string;
      startedAt?: any | null;
      endedAt: any;
      videos: Array<string>;
      createdAt: any;
      media: Array<{
        __typename?: "JobApplicationMediaItem";
        key: string;
        mimeType: string;
        originalUrl: string;
        thumbnailUrl: string;
      }>;
    }>;
    certifications: Array<{
      __typename?: "JobApplicationCertification";
      id?: string | null;
      name: string;
      issuerCertificationId?: string | null;
      issuedBy: string;
      issuedAt: any;
      url?: string | null;
      createdAt: any;
    }>;
  }>;
};

export type MyPortfolioForJobApplicationPrefillQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MyPortfolioForJobApplicationPrefillQuery = {
  __typename?: "Query";
  myPortfolio?: {
    __typename?: "ProPortfolio";
    workHistory: Array<{
      __typename?: "PortfolioWorkHistoryItem";
      id?: string | null;
      name: string;
      description: string;
      startedAt?: any | null;
      endedAt: any;
      images: Array<{
        __typename?: "PortfolioImage";
        key?: string | null;
        mimeType: string;
        originalUrl?: string | null;
        thumbnailUrl?: string | null;
      }>;
    }>;
    employmentHistory: Array<{
      __typename?: "PortfolioEmploymentHistoryItem";
      id: string;
      companyName: string;
      jobTitle: string;
      description: string;
      startedAt: any;
      endedAt?: any | null;
      images: Array<{
        __typename?: "PortfolioImage";
        key?: string | null;
        mimeType: string;
        originalUrl?: string | null;
        thumbnailUrl?: string | null;
      }>;
    }>;
    certifications: Array<{
      __typename?: "PortfolioCertification";
      id?: string | null;
      name: string;
      issuedBy: string;
      issuedAt: any;
      issuerCertificationId?: string | null;
      url?: string | null;
    }>;
    educationEntries: Array<{
      __typename?: "PortfolioEducation";
      id?: string | null;
      schoolName: string;
      fieldOfStudy?: string | null;
      qualification: EducationLevel;
    }>;
  } | null;
};

export type DoesProExistQueryVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type DoesProExistQuery = {
  __typename?: "Query";
  doesProExistWithEmail: boolean;
};

export type DoesApplicantExistQueryVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type DoesApplicantExistQuery = {
  __typename?: "Query";
  doesApplicantExistWithEmail: boolean;
};

export type MyJobApplicantProfileQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MyJobApplicantProfileQuery = {
  __typename?: "Query";
  myJobApplicantProfile?: {
    __typename?: "BaseJobApplicant";
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    yearsOfExperience?: number | null;
    pro?: { __typename?: "Pro"; id: string } | null;
  } | null;
};

export type CreateRecruiterJobApplicationLoggedInMutationVariables = Exact<{
  input: CreateJobApplicationDto;
}>;

export type CreateRecruiterJobApplicationLoggedInMutation = {
  __typename?: "Mutation";
  createRecruiterJobApplicationLoggedIn: {
    __typename?: "EmployerJobApplication";
    id: string;
    status: ApplicationStatus;
    createdAt: any;
    applicant: {
      __typename?: "BaseJobApplicant";
      pro?: { __typename?: "Pro"; id: string } | null;
    };
    applicantSnapshot: {
      __typename?: "ApplicantSnapshot";
      email: string;
      firstName: string;
      lastName: string;
      phoneNumber: string;
      yearsOfExperience?: number | null;
    };
  };
};

export type CreateRecruiterJobApplicationNotLoggedInMutationVariables = Exact<{
  input: CreateJobApplicationDto;
}>;

export type CreateRecruiterJobApplicationNotLoggedInMutation = {
  __typename?: "Mutation";
  createRecruiterJobApplicationNotLoggedIn: {
    __typename?: "EmployerJobApplication";
    id: string;
    status: ApplicationStatus;
    createdAt: any;
    applicant: {
      __typename?: "BaseJobApplicant";
      pro?: { __typename?: "Pro"; id: string } | null;
    };
    applicantSnapshot: {
      __typename?: "ApplicantSnapshot";
      email: string;
      firstName: string;
      lastName: string;
      phoneNumber: string;
      yearsOfExperience?: number | null;
    };
  };
};

export type AddPortfolioCertificationMutationVariables = Exact<{
  name: Scalars["String"]["input"];
  issuedBy: Scalars["String"]["input"];
  issuerCertificationId?: InputMaybe<Scalars["String"]["input"]>;
  issuedAt: Scalars["DateTimeISO"]["input"];
}>;

export type AddPortfolioCertificationMutation = {
  __typename?: "Mutation";
  addPortfolioCertification: boolean;
};

export type EditPortfolioCertificationMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  issuedBy?: InputMaybe<Scalars["String"]["input"]>;
  issuerCertificationId?: InputMaybe<Scalars["String"]["input"]>;
  issuedAt?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type EditPortfolioCertificationMutation = {
  __typename?: "Mutation";
  editPortfolioCertification: {
    __typename?: "PortfolioCertification";
    id?: string | null;
    name: string;
    issuedBy: string;
    issuerCertificationId?: string | null;
    issuedAt: any;
    url?: string | null;
  };
};

export type RemovePortfolioCertificationMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type RemovePortfolioCertificationMutation = {
  __typename?: "Mutation";
  removePortfolioCertification: {
    __typename?: "PortfolioCertification";
    id?: string | null;
  };
};

export type ToggleEmploymentHistoryItemPinMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type ToggleEmploymentHistoryItemPinMutation = {
  __typename?: "Mutation";
  togglePortfolioEmploymentHistoryItemPin: {
    __typename?: "PortfolioEmploymentHistoryItem";
    id: string;
    isPinned?: boolean | null;
  };
};

export type ProPortfolioWithoutMediaQueryVariables = Exact<{
  handle: Scalars["String"]["input"];
}>;

export type ProPortfolioWithoutMediaQuery = {
  __typename?: "Query";
  proPortfolio?: {
    __typename?: "ProPortfolio";
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    isEmailHidden?: boolean | null;
    backgroundCheckStatus: ProPortfolioBadgeStatus;
    identityVerificationStatus: ProPortfolioBadgeStatus;
    title?: string | null;
    location?: string | null;
    averageRating: number;
    ratingCount: number;
    overview?: string | null;
    experience?: number | null;
    employmentHistory: Array<{
      __typename?: "PortfolioEmploymentHistoryItem";
      id: string;
      isPinned?: boolean | null;
      companyName: string;
      jobTitle: string;
      description: string;
      startedAt: any;
      endedAt?: any | null;
      createdAt: any;
      images: Array<{
        __typename?: "PortfolioImage";
        id: string;
        name: string;
        mimeType: string;
        originalUrl?: string | null;
        thumbnailUrl?: string | null;
        deletedAt?: any | null;
      }>;
    }>;
    workHistory: Array<{
      __typename?: "PortfolioWorkHistoryItem";
      id?: string | null;
      name: string;
      description: string;
      startedAt?: any | null;
      endedAt: any;
      verified?: boolean | null;
      isPinned?: boolean | null;
      createdAt: any;
      images: Array<{
        __typename?: "PortfolioImage";
        id: string;
        name: string;
        mimeType: string;
        originalUrl?: string | null;
        thumbnailUrl?: string | null;
        deletedAt?: any | null;
      }>;
      clientReview?: {
        __typename?: "PortfolioWorkHistoryItemClientReview";
        rating: number;
        feedback?: string | null;
      } | null;
    }>;
    certifications: Array<{
      __typename?: "PortfolioCertification";
      id?: string | null;
      name: string;
      issuedBy: string;
      issuedAt: any;
      issuerCertificationId?: string | null;
      url?: string | null;
      verified?: boolean | null;
      createdAt: any;
    }>;
    educationEntries: Array<{
      __typename?: "PortfolioEducation";
      id?: string | null;
      schoolName: string;
      fieldOfStudy?: string | null;
      qualification: EducationLevel;
      verified?: boolean | null;
      createdAt: any;
    }>;
    averageLaborHackJobsRatings: {
      __typename?: "AverageLaborHackJobsRatings";
      averageAppearanceRating: number;
      averagePunctualityRating: number;
      averagePostServiceCleanUpRating: number;
      averageBehaviorRating: number;
      averageProperToolUsageRating: number;
    };
  } | null;
};

export type TogglePortfolioWorkHistoryItemPinMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type TogglePortfolioWorkHistoryItemPinMutation = {
  __typename?: "Mutation";
  togglePortfolioWorkHistoryItemPin: {
    __typename?: "PortfolioWorkHistoryItem";
    id?: string | null;
    isPinned?: boolean | null;
  };
};

export type CreateProjectOutsourcingTaskMutationVariables = Exact<{
  projectOutsourcingDto: ProjectOutsourcingDto;
}>;

export type CreateProjectOutsourcingTaskMutation = {
  __typename?: "Mutation";
  createProjectOutsourcingTask: string;
};

export type RequestConstructionProjectMutationVariables = Exact<{
  constructionProjectRequestDto: ConstructionProjectRequestDto;
}>;

export type RequestConstructionProjectMutation = {
  __typename?: "Mutation";
  requestConstructionProject: string;
};

export type RequestFacilityMaintenanceMutationVariables = Exact<{
  facilityMaintenanceRequestDto: FacilityMaintenanceRequestDto;
}>;

export type RequestFacilityMaintenanceMutation = {
  __typename?: "Mutation";
  requestFacilityMaintenance: string;
};

export type RequestRenovationProjectMutationVariables = Exact<{
  renovationProjectRequestDto: RenovationProjectRequestDto;
}>;

export type RequestRenovationProjectMutation = {
  __typename?: "Mutation";
  requestRenovationProject: string;
};

export type CreateRecruitmentConsultationTaskMutationVariables = Exact<{
  recruitmentConsultationDto: RecruitmentConsultationDto;
}>;

export type CreateRecruitmentConsultationTaskMutation = {
  __typename?: "Mutation";
  createRecruitmentConsultationTask: string;
};

export type CreateLeadMutationVariables = Exact<{
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  referrer?: InputMaybe<Scalars["String"]["input"]>;
  source: Scalars["String"]["input"];
}>;

export type CreateLeadMutation = {
  __typename?: "Mutation";
  createLead: { __typename?: "Lead"; id: string };
};

export type RegisterNewClientMutationVariables = Exact<{
  data: RegisterNewClientInput;
}>;

export type RegisterNewClientMutation = {
  __typename?: "Mutation";
  registerNewClient: {
    __typename?: "CreateClientResponse";
    status: boolean;
    message: string;
  };
};

export type CategoriesQueryVariables = Exact<{
  includeCustomPackages?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CategoriesQuery = {
  __typename?: "Query";
  categories: Array<{
    __typename?: "Category";
    id: string;
    name: string;
    proTitle?: string | null;
    imageUrl?: string | null;
    requestCount?: number | null;
    priority: number;
    packages?: Array<{
      __typename?: "CategorySubscriptionPackage";
      name: string;
      maximumCalls: number;
      baseInterval: string;
      id: string;
      isCustom?: boolean | null;
      plans: Array<{
        __typename?: "CategorySubscriptionPackagePlan";
        id: string;
        interval: SubscriptionInterval;
        discount?: number | null;
        costBreakdown: {
          __typename?: "CategorySubscriptionPackagePlanCostBreakdown";
          discount: number;
          subTotal: number;
          tax: number;
          total: number;
        };
        price: { __typename?: "CategorySubscriptionPackagePrice"; id: string };
      }>;
    }> | null;
  }>;
};

export type GetUserByEmailQueryVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type GetUserByEmailQuery = {
  __typename?: "Query";
  getUserRecordByEmail: { __typename?: "User"; id: string; email: string };
};

export type GetUserByPhoneNumberQueryVariables = Exact<{
  phoneNumber: Scalars["String"]["input"];
}>;

export type GetUserByPhoneNumberQuery = {
  __typename?: "Query";
  getUserRecordByPhoneNumber: {
    __typename?: "User";
    id: string;
    phoneNumber: string;
  };
};

export type GetBusinessByEmailQueryVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type GetBusinessByEmailQuery = {
  __typename?: "Query";
  businessByEmail: {
    __typename?: "Business";
    id: string;
    email?: string | null;
    phoneNumber?: string | null;
  };
};

export type GetMyLocationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyLocationsQuery = {
  __typename?: "Query";
  getMyLocations: {
    __typename?: "GetClientLocationsResponse";
    status: boolean;
    message: string;
    data: {
      __typename?: "ClientLocationData";
      defaultLocationId?: string | null;
      locations: Array<{
        __typename?: "Location";
        buildingNumber?: string | null;
        streetName: string;
        city: string;
        landmark?: string | null;
        area: string;
        location: string;
        id: string;
      }>;
    };
  };
};

export type MyClientQueryVariables = Exact<{ [key: string]: never }>;

export type MyClientQuery = {
  __typename?: "Query";
  myClient?: {
    __typename?: "Client";
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
  } | null;
};

export type LogServerEventMutationVariables = Exact<{
  event: EventTypes;
  data: Array<LogEventContextFieldArgs> | LogEventContextFieldArgs;
}>;

export type LogServerEventMutation = {
  __typename?: "Mutation";
  logEvent: boolean;
};

export type GetMyProProfileQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyProProfileQuery = {
  __typename?: "Query";
  myProInformation: {
    __typename?: "Pro";
    id: string;
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    yearsOfExperience?: number | null;
    phoneNumber: string;
    overview?: string | null;
    proApplication?: {
      __typename?: "ProApplication";
      country: string;
      dateOfBirth?: any | null;
      gender: Gender;
      detailedAddress?: {
        __typename?: "Address";
        address: string;
        city: string;
        state: string;
        placeId?: string | null;
      } | null;
    } | null;
  };
};

export type MarkApprovalMutationVariables = Exact<{
  token: Scalars["String"]["input"];
  contacts?: InputMaybe<
    Array<CreateBusinessClientInput> | CreateBusinessClientInput
  >;
}>;

export type MarkApprovalMutation = {
  __typename?: "Mutation";
  markBusinessAsApproved: {
    __typename?: "AccountActivation";
    id: string;
    client?: { __typename?: "Client"; id: string } | null;
  };
};

export type GetActivationQueryVariables = Exact<{
  token: Scalars["String"]["input"];
}>;

export type GetActivationQuery = {
  __typename?: "Query";
  accountActivationByToken: {
    __typename?: "AccountActivation";
    id: string;
    client?: { __typename?: "Client"; id: string } | null;
  };
};

export type SaveBusinessMutationVariables = Exact<{
  payload: SaveBusinessInput;
}>;

export type SaveBusinessMutation = {
  __typename?: "Mutation";
  saveBusiness: {
    __typename?: "Business";
    id: string;
    name: string;
    clients: Array<{
      __typename?: "Client";
      id: string;
      firstName: string;
      phoneNumber: string;
    }>;
  };
};

export type WaitlistMutationVariables = Exact<{
  input: CreateWaitlistedBusinessInput;
}>;

export type WaitlistMutation = {
  __typename?: "Mutation";
  waitlistBusiness: {
    __typename?: "WaitlistedBusiness";
    id: string;
    name: string;
    contacts: Array<{
      __typename?: "WaitlistedContact";
      name: string;
      email: string;
    }>;
  };
};

export type ResendMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type ResendMutation = {
  __typename?: "Mutation";
  resendWaitlistedBusinessVerificationCode: {
    __typename?: "WaitlistedBusiness";
    id: string;
  };
};

export type VerifyMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  code: Scalars["String"]["input"];
}>;

export type VerifyMutation = {
  __typename?: "Mutation";
  verifyWaitlistedBusinessVerificationCode: {
    __typename?: "WaitlistedBusiness";
    id: string;
    contacts: Array<{
      __typename?: "WaitlistedContact";
      emailVerified: boolean;
    }>;
  };
};

export type CreateEnquiryMutationVariables = Exact<{
  name: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  accountType: AccountType;
  message: Scalars["String"]["input"];
  joinedMailingList: Scalars["Boolean"]["input"];
}>;

export type CreateEnquiryMutation = {
  __typename?: "Mutation";
  createEnquiry: boolean;
};

export type ListClientInvoicesQueryVariables = Exact<{ [key: string]: never }>;

export type ListClientInvoicesQuery = {
  __typename?: "Query";
  getClientInvoices: Array<{
    __typename?: "Invoice";
    id: string;
    type?: InvoiceType | null;
    canceled: boolean;
    inspectionAmount?: number | null;
    invoiceNumber: number;
    invoiceDate: any;
    due?: any | null;
    discount?: number | null;
    isFullyPaid: boolean;
    hasAtLeastOnePayment: boolean;
    assignments?: Array<{
      __typename?: "TradesmanAssignment";
      id: string;
      progress?: AssignmentProgress | null;
      date: any;
      order: {
        __typename?: "Order";
        id: string;
        orderCode: string;
        isEmergency?: boolean | null;
        inspectionPayment?: {
          __typename?: "Payment";
          status: TransactionStatus;
          amount: number;
        } | null;
        locationSchedules: Array<{
          __typename?: "LocationSchedule";
          locationId: string;
          scheduledDate: any;
        }>;
      };
      jobs: Array<{
        __typename?: "Job";
        id: string;
        jobCode: string;
        finalCost?: number | null;
        status: Status;
        completedAt?: any | null;
        custom?: {
          __typename?: "JobCustomTask";
          name: string;
          description: string;
          resourceUrl?: string | null;
          subCategoryId?: string | null;
          categoryId: string;
        } | null;
        task?: {
          __typename?: "Task";
          id?: string | null;
          name?: string | null;
          description?: string | null;
          estimatedCost?: number | null;
          categoryId?: string | null;
          subCategoryId?: string | null;
          imageUrl?: string | null;
        } | null;
        payment?: {
          __typename?: "Payment";
          transactionReference: string;
          transactionDate?: any | null;
          amount: number;
          status: TransactionStatus;
        } | null;
        contact: {
          __typename?: "Contact";
          notes?: string | null;
          location: {
            __typename?: "Location";
            id: string;
            buildingNumber?: string | null;
            streetName: string;
            area: string;
            location: string;
            landmark?: string | null;
            city: string;
          };
        };
        invoiceDetails?: {
          __typename?: "InvoiceDetails";
          labor?: number | null;
          materials?: Array<{
            __typename?: "InvoiceMaterial";
            name: string;
            unitPrice: number;
            quantity: number;
          }> | null;
        } | null;
      }>;
    }> | null;
    recipient: {
      __typename?: "Recipient";
      name: string;
      email: string;
      phoneNumber: string;
      address: Array<string>;
    };
    payment?: {
      __typename?: "Payment";
      id: string;
      transactionDate?: any | null;
      transactionReference: string;
      amount: number;
      status: TransactionStatus;
    } | null;
    splitPayments?: Array<{
      __typename?: "SplitPayment";
      percentage: number;
      payment?: {
        __typename?: "Payment";
        id: string;
        transactionDate?: any | null;
        transactionReference: string;
        amount: number;
        status: TransactionStatus;
      } | null;
    }> | null;
  }>;
};

export type AddLocationMutationVariables = Exact<{
  input: AddLocationInput;
}>;

export type AddLocationMutation = {
  __typename?: "Mutation";
  addLocation: { __typename?: "Location"; id: string };
};

export type SetLocationAsDefaultMutationVariables = Exact<{
  locationId: Scalars["String"]["input"];
}>;

export type SetLocationAsDefaultMutation = {
  __typename?: "Mutation";
  setLocationAsDefault: {
    __typename?: "DefaultResponse";
    status: boolean;
    message: string;
  };
};

export type ListClientOrdersQueryVariables = Exact<{ [key: string]: never }>;

export type ListClientOrdersQuery = {
  __typename?: "Query";
  clientOrders: Array<{
    __typename?: "ClientOrderListItem";
    id: string;
    orderCode: string;
    categories: Array<string>;
    taskCount: number;
    inspectionFeePaid: boolean;
    totalCost?: number | null;
    assigned: string;
    status: OrderStatus;
    createdAt: any;
  }>;
};

export type CreateReviewMutationVariables = Exact<{
  input: CreateReviewInput;
}>;

export type CreateReviewMutation = {
  __typename?: "Mutation";
  createReview: {
    __typename?: "DefaultResponse";
    status: boolean;
    message: string;
  };
};

export type CreateReferralMutationVariables = Exact<{
  referredEmail: Scalars["String"]["input"];
}>;

export type CreateReferralMutation = {
  __typename?: "Mutation";
  createReferral: {
    __typename?: "DefaultResponse";
    status: boolean;
    message: string;
  };
};

export type UpdateMutationVariables = Exact<{
  payload: EditClientInput;
}>;

export type UpdateMutation = {
  __typename?: "Mutation";
  updateClient: {
    __typename?: "Client";
    id: string;
    lastNotificationViewedAt?: any | null;
  };
};

export type EditUserMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type EditUserMutation = {
  __typename?: "Mutation";
  user: { __typename?: "User"; id: string; firstName: string };
};

export type GetOrderQueryVariables = Exact<{
  code: Scalars["String"]["input"];
}>;

export type GetOrderQuery = {
  __typename?: "Query";
  getOrder: {
    __typename?: "Order";
    id: string;
    orderCode: string;
    isEmergency?: boolean | null;
    client?: {
      __typename?: "OrderUser";
      userId?: string | null;
      name?: string | null;
      phoneNumber?: string | null;
    } | null;
    locationSchedules: Array<{
      __typename?: "LocationSchedule";
      scheduledDate: any;
    }>;
    jobs: Array<{
      __typename?: "Job";
      id: string;
      jobCode: string;
      finalCost?: number | null;
      status: Status;
      completedAt?: any | null;
      custom?: {
        __typename?: "JobCustomTask";
        name: string;
        description: string;
        resourceUrl?: string | null;
        subCategoryId?: string | null;
        categoryId: string;
      } | null;
      task?: {
        __typename?: "Task";
        id?: string | null;
        name?: string | null;
        description?: string | null;
        estimatedCost?: number | null;
        categoryId?: string | null;
        subCategoryId?: string | null;
        imageUrl?: string | null;
      } | null;
      payment?: {
        __typename?: "Payment";
        transactionReference: string;
        transactionDate?: any | null;
        amount: number;
        status: TransactionStatus;
      } | null;
      contact: {
        __typename?: "Contact";
        notes?: string | null;
        location: {
          __typename?: "Location";
          buildingNumber?: string | null;
          streetName: string;
          area: string;
          location: string;
          landmark?: string | null;
          city: string;
        };
      };
      invoiceDetails?: {
        __typename?: "InvoiceDetails";
        labor?: number | null;
        materials?: Array<{
          __typename?: "InvoiceMaterial";
          name: string;
          unitPrice: number;
          quantity: number;
        }> | null;
      } | null;
    }>;
    assignments: Array<{
      __typename?: "TradesmanAssignment";
      id: string;
      progress?: AssignmentProgress | null;
      inspectionWaived?: boolean | null;
      date: any;
      inspectionPayment?: {
        __typename?: "Payment";
        transactionReference: string;
        transactionDate?: any | null;
        amount: number;
        status: TransactionStatus;
      } | null;
      invoice?: {
        __typename?: "Invoice";
        id: string;
        invoiceNumber: number;
        invoiceDate: any;
        type?: InvoiceType | null;
        sent: boolean;
        inspectionAmount?: number | null;
        isFullyPaid: boolean;
        hasAtLeastOnePayment: boolean;
        payment?: {
          __typename?: "Payment";
          id: string;
          status: TransactionStatus;
          amount: number;
          transactionReference: string;
          transactionDate?: any | null;
        } | null;
        splitPayments?: Array<{
          __typename?: "SplitPayment";
          percentage: number;
          payment?: {
            __typename?: "Payment";
            id: string;
            status: TransactionStatus;
            amount: number;
            transactionDate?: any | null;
          } | null;
        }> | null;
      } | null;
      jobs: Array<{
        __typename?: "Job";
        id: string;
        jobCode: string;
        finalCost?: number | null;
        status: Status;
        completedAt?: any | null;
        custom?: {
          __typename?: "JobCustomTask";
          name: string;
          description: string;
          resourceUrl?: string | null;
          subCategoryId?: string | null;
          categoryId: string;
        } | null;
        task?: {
          __typename?: "Task";
          id?: string | null;
          name?: string | null;
          description?: string | null;
          estimatedCost?: number | null;
          categoryId?: string | null;
          subCategoryId?: string | null;
          imageUrl?: string | null;
        } | null;
        payment?: {
          __typename?: "Payment";
          transactionReference: string;
          transactionDate?: any | null;
          amount: number;
          status: TransactionStatus;
        } | null;
        contact: {
          __typename?: "Contact";
          notes?: string | null;
          location: {
            __typename?: "Location";
            buildingNumber?: string | null;
            streetName: string;
            area: string;
            location: string;
            landmark?: string | null;
            city: string;
          };
        };
        invoiceDetails?: {
          __typename?: "InvoiceDetails";
          labor?: number | null;
          materials?: Array<{
            __typename?: "InvoiceMaterial";
            name: string;
            unitPrice: number;
            quantity: number;
          }> | null;
        } | null;
      }>;
      tradesman: {
        __typename?: "Tradesman";
        id: string;
        userId: string;
        firstName?: string | null;
        lastName?: string | null;
        imageUrl?: string | null;
        email?: string | null;
        level: number;
        categoryId: string;
        rewardPoints?: number | null;
        rating?: number | null;
        phoneNumber?: string | null;
        location: {
          __typename?: "Location";
          buildingNumber?: string | null;
          streetName: string;
          area: string;
          location: string;
          landmark?: string | null;
          city: string;
        };
      };
    }>;
  };
};

export type GetInvoicesQueryVariables = Exact<{
  orderId: Scalars["String"]["input"];
  type?: InputMaybe<InvoiceType>;
}>;

export type GetInvoicesQuery = {
  __typename?: "Query";
  getInvoicesByOrder: Array<{
    __typename?: "Invoice";
    id: string;
    type?: InvoiceType | null;
    sent: boolean;
    canceled: boolean;
    inspectionAmount?: number | null;
    invoiceNumber: number;
    invoiceDate: any;
    discount?: number | null;
    isFullyPaid: boolean;
    hasAtLeastOnePayment: boolean;
    appliedDiscount?: {
      __typename?: "InvoiceDiscount";
      id: string;
      code: string;
      value: number;
    } | null;
    splitPayments?: Array<{
      __typename?: "SplitPayment";
      percentage: number;
      payment?: {
        __typename?: "Payment";
        id: string;
        status: TransactionStatus;
        amount: number;
        transactionDate?: any | null;
      } | null;
    }> | null;
    assignments?: Array<{
      __typename?: "TradesmanAssignment";
      id: string;
      progress?: AssignmentProgress | null;
      date: any;
      order: {
        __typename?: "Order";
        id: string;
        orderCode: string;
        isEmergency?: boolean | null;
        inspectionPayment?: {
          __typename?: "Payment";
          status: TransactionStatus;
          amount: number;
        } | null;
        locationSchedules: Array<{
          __typename?: "LocationSchedule";
          locationId: string;
          scheduledDate: any;
        }>;
      };
      jobs: Array<{
        __typename?: "Job";
        id: string;
        jobCode: string;
        finalCost?: number | null;
        status: Status;
        completedAt?: any | null;
        custom?: {
          __typename?: "JobCustomTask";
          name: string;
          description: string;
          resourceUrl?: string | null;
          subCategoryId?: string | null;
          categoryId: string;
        } | null;
        task?: {
          __typename?: "Task";
          id?: string | null;
          name?: string | null;
          description?: string | null;
          estimatedCost?: number | null;
          categoryId?: string | null;
          subCategoryId?: string | null;
          imageUrl?: string | null;
        } | null;
        payment?: {
          __typename?: "Payment";
          transactionReference: string;
          transactionDate?: any | null;
          amount: number;
          status: TransactionStatus;
        } | null;
        contact: {
          __typename?: "Contact";
          notes?: string | null;
          location: {
            __typename?: "Location";
            id: string;
            buildingNumber?: string | null;
            streetName: string;
            area: string;
            location: string;
            landmark?: string | null;
            city: string;
          };
        };
        invoiceDetails?: {
          __typename?: "InvoiceDetails";
          labor?: number | null;
          materials?: Array<{
            __typename?: "InvoiceMaterial";
            name: string;
            unitPrice: number;
            quantity: number;
          }> | null;
        } | null;
      }>;
    }> | null;
    recipient: {
      __typename?: "Recipient";
      name: string;
      email: string;
      phoneNumber: string;
      address: Array<string>;
    };
    payment?: {
      __typename?: "Payment";
      id: string;
      transactionDate?: any | null;
      transactionReference: string;
      status: TransactionStatus;
    } | null;
  }>;
};

export type GetNotificationsSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type GetNotificationsSubscription = {
  __typename?: "Subscription";
  newClientNotification:
    | {
        __typename?: "InvoiceNotificationPayload";
        event: NotificationEvent;
        invoice: {
          __typename?: "NotificationPayloadInvoice";
          invoiceId: string;
          type?: string | null;
          invoiceNumber: number;
          amount: number;
        };
        order: {
          __typename?: "NotificationPayloadOrder";
          id: string;
          orderCode: string;
        };
      }
    | {
        __typename?: "ProDispatchedNotificationPayload";
        event: NotificationEvent;
      }
    | {
        __typename?: "TextNotificationPayload";
        event: NotificationEvent;
        text: { __typename?: "NotificationPayloadText"; body: string };
      };
};

export type ConfirmInvoicePaymentMutationVariables = Exact<{
  invoiceId: Scalars["String"]["input"];
  transactionId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ConfirmInvoicePaymentMutation = {
  __typename?: "Mutation";
  confirmInvoicePayment: {
    __typename?: "DefaultResponse";
    status: boolean;
    message: string;
  };
};

export type ActivateJobMutationVariables = Exact<{
  jobId: Scalars["String"]["input"];
}>;

export type ActivateJobMutation = {
  __typename?: "Mutation";
  activateJob: {
    __typename?: "DefaultResponse";
    status: boolean;
    message: string;
  };
};

export type ArchiveJobMutationVariables = Exact<{
  jobId: Scalars["String"]["input"];
}>;

export type ArchiveJobMutation = {
  __typename?: "Mutation";
  archiveJob: {
    __typename?: "DefaultResponse";
    status: boolean;
    message: string;
  };
};

export type GetInvoicePaymentLinkMutationVariables = Exact<{
  invoiceId: Scalars["String"]["input"];
  providerId: Scalars["String"]["input"];
  callback?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetInvoicePaymentLinkMutation = {
  __typename?: "Mutation";
  getInvoicePaymentLink: {
    __typename?: "GetInvoicePaymentLinkResponse";
    status: boolean;
    message: string;
    data: { __typename?: "InvoicePaymentLink"; paymentUrl: string };
  };
};

export type ApplyDiscountMutationVariables = Exact<{
  invoiceId: Scalars["String"]["input"];
  discountCode: Scalars["String"]["input"];
}>;

export type ApplyDiscountMutation = {
  __typename?: "Mutation";
  applyInvoiceDiscountCode: {
    __typename?: "Invoice";
    id: string;
    type?: InvoiceType | null;
    discount?: number | null;
    appliedDiscount?: {
      __typename?: "InvoiceDiscount";
      id: string;
      code: string;
      value: number;
    } | null;
  };
};

export type GetPaymentProvidersQueryVariables = Exact<{
  amount: Scalars["Float"]["input"];
}>;

export type GetPaymentProvidersQuery = {
  __typename?: "Query";
  paymentProviders: Array<{
    __typename?: "PaymentProvider";
    id: string;
    name: string;
    logo: string;
    transactionFee: number;
    isActive: boolean;
  }>;
};

export type GetNextInvoicePaymentQueryVariables = Exact<{
  invoiceId: Scalars["String"]["input"];
}>;

export type GetNextInvoicePaymentQuery = {
  __typename?: "Query";
  nextInvoicePayment: {
    __typename?: "NextInvoicePayment";
    total: number;
    serviceCharge?: number | null;
    discount?: number | null;
    subTotal?: number | null;
    materials?: number | null;
    labor?: number | null;
    laborHackFee?: number | null;
    nextPaymentPercentage: number;
    laborCommission?: number | null;
    materialCommission?: number | null;
    tax?: number | null;
  };
};

export type GetInvoiceQueryVariables = Exact<{
  invoiceId: Scalars["String"]["input"];
}>;

export type GetInvoiceQuery = {
  __typename?: "Query";
  getInvoiceById: {
    __typename?: "GetInvoiceResponse";
    status: boolean;
    message: string;
    data: {
      __typename?: "Invoice";
      id: string;
      type?: InvoiceType | null;
      canceled: boolean;
      inspectionAmount?: number | null;
      invoiceNumber: number;
      invoiceDate: any;
      isFullyPaid: boolean;
      hasAtLeastOnePayment: boolean;
      allowedPaymentProviders: Array<string>;
      due?: any | null;
      discount?: number | null;
      renderingData?: {
        __typename?: "InvoiceRenderingData";
        headers: Array<string>;
        sections: Array<{
          __typename?: "InvoiceItemsSection";
          title?: string | null;
          rows: Array<{
            __typename?: "InvoiceLineRow";
            cells: Array<{
              __typename?: "InvoiceLineItemCell";
              subText?: Array<string> | null;
              text?: string | null;
            }>;
          }>;
        }>;
      } | null;
      pricing?: {
        __typename?: "InvoicePricing";
        serviceCharge: number;
        cost: number;
        options?: {
          __typename?: "InvoicePricingOptions";
          hideServiceCharge?: boolean | null;
        } | null;
      } | null;
      reimbursements?: Array<{
        __typename?: "ContractPayoutReimbursement";
        id: string;
        excludeTax?: boolean | null;
        payout: {
          __typename?: "ContractPayout";
          id: string;
          worksheet: {
            __typename?: "ContractWorksheet";
            contract: {
              __typename?: "ProRecruitmentContract";
              pro: { __typename?: "Pro"; firstName: string; lastName: string };
            };
            payroll: {
              __typename?: "RecruitmentPayroll";
              period: {
                __typename?: "RecruitmentPayrollPeriod";
                start: any;
                end: any;
              };
            };
          };
          breakdown: {
            __typename?: "ContractPayoutBreakdown";
            gross: number;
            net: number;
            tax?: number | null;
          };
        };
      }> | null;
      marketplaceRequest?: {
        __typename?: "MarketplaceRequest";
        id: string;
        jobs: Array<{
          __typename?: "MarketplaceJob";
          trade: { __typename?: "Trade"; name: string };
          matches: Array<{
            __typename?: "MarketplaceMatch";
            pro: { __typename?: "MarketplaceMatchPro"; id: string };
          }>;
        }>;
      } | null;
      recruitment?: {
        __typename?: "ContractRecruitment";
        id: string;
        jobs: Array<{
          __typename?: "RecruitmentJob";
          category: { __typename?: "Trade"; name: string };
          matches: Array<{
            __typename?: "RecruitmentMatch";
            pro: { __typename?: "RecruitmentMatchPro"; id: string };
          }>;
        }>;
      } | null;
      recruitmentData?: Array<{
        __typename?: "RecruitmentData";
        numberOfBilledDays: number;
        agreedDailyRate: number;
        contract?: {
          __typename?: "Contract";
          id: string;
          contractInterval: ContractInterval;
          contractLength: number;
          proLevel: number;
          pro?: {
            __typename?: "Tradesman";
            firstName?: string | null;
            lastName?: string | null;
            categoryId: string;
          } | null;
        } | null;
        period: { __typename?: "Period"; start: any; end: any };
      }> | null;
      appliedDiscount?: {
        __typename?: "InvoiceDiscount";
        id: string;
        code: string;
        value: number;
      } | null;
      assignments?: Array<{
        __typename?: "TradesmanAssignment";
        id: string;
        progress?: AssignmentProgress | null;
        date: any;
        order: {
          __typename?: "Order";
          id: string;
          orderCode: string;
          isEmergency?: boolean | null;
          inspectionPayment?: {
            __typename?: "Payment";
            status: TransactionStatus;
            amount: number;
          } | null;
          locationSchedules: Array<{
            __typename?: "LocationSchedule";
            locationId: string;
            scheduledDate: any;
          }>;
        };
        jobs: Array<{
          __typename?: "Job";
          id: string;
          jobCode: string;
          finalCost?: number | null;
          status: Status;
          completedAt?: any | null;
          custom?: {
            __typename?: "JobCustomTask";
            name: string;
            description: string;
            resourceUrl?: string | null;
            subCategoryId?: string | null;
            categoryId: string;
          } | null;
          task?: {
            __typename?: "Task";
            id?: string | null;
            name?: string | null;
            description?: string | null;
            estimatedCost?: number | null;
            categoryId?: string | null;
            subCategoryId?: string | null;
            imageUrl?: string | null;
          } | null;
          payment?: {
            __typename?: "Payment";
            transactionReference: string;
            transactionDate?: any | null;
            amount: number;
            status: TransactionStatus;
          } | null;
          contact: {
            __typename?: "Contact";
            notes?: string | null;
            location: {
              __typename?: "Location";
              id: string;
              buildingNumber?: string | null;
              streetName: string;
              area: string;
              location: string;
              landmark?: string | null;
              city: string;
            };
          };
          invoiceDetails?: {
            __typename?: "InvoiceDetails";
            labor?: number | null;
            materials?: Array<{
              __typename?: "InvoiceMaterial";
              name: string;
              unitPrice: number;
              quantity: number;
            }> | null;
          } | null;
        }>;
      }> | null;
      recipient: {
        __typename?: "Recipient";
        name: string;
        email: string;
        phoneNumber: string;
        address: Array<string>;
      };
      payment?: {
        __typename?: "Payment";
        id: string;
        transactionDate?: any | null;
        transactionReference: string;
        amount: number;
        status: TransactionStatus;
      } | null;
      splitPayments?: Array<{
        __typename?: "SplitPayment";
        percentage: number;
        payment?: {
          __typename?: "Payment";
          id: string;
          transactionDate?: any | null;
          transactionReference: string;
          amount: number;
          status: TransactionStatus;
        } | null;
      }> | null;
    };
  };
};

export type GetJobAdForApplicationQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetJobAdForApplicationQuery = {
  __typename?: "Query";
  getEmployerJobAd?: {
    __typename?: "EmployerJobAd";
    id: string;
    title: string;
    description: string;
    employmentType: EmploymentType;
    companyName: string;
    hasApplied: boolean;
    canApply: boolean;
    organization: { __typename?: "Organization"; name: string };
    principal?: { __typename?: "EmployerJobAdPrincipal"; name: string } | null;
    location: {
      __typename?: "EmployerJobAdLocation";
      area: string;
      state: string;
      country: string;
    };
    salaryDetails?: {
      __typename?: "SalaryDetails";
      starting: number;
      cap?: number | null;
      currencyCode: string;
    } | null;
    duration?: {
      __typename?: "DurationDetails";
      value: number;
      type: DurationType;
    } | null;
    tags: Array<{ __typename?: "JobAdTag"; id: string; name: string }>;
    categories: Array<{ __typename?: "Category"; name: string }>;
  } | null;
};

export type UpdateGuestApplicantUserIdMutationVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type UpdateGuestApplicantUserIdMutation = {
  __typename?: "Mutation";
  updateGuestApplicantUserId: boolean;
};

export type GetJobAdQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetJobAdQuery = {
  __typename?: "Query";
  getEmployerJobAd?: {
    __typename?: "EmployerJobAd";
    id: string;
    title: string;
    description: string;
    companyName: string;
    createdAt: any;
    employmentType: EmploymentType;
    visibility: JobVisibility;
    hasApplied: boolean;
    canApply: boolean;
    applicationDeadline?: any | null;
    salaryDetails?: {
      __typename?: "SalaryDetails";
      starting: number;
      cap?: number | null;
      currencyCode: string;
    } | null;
    duration?: {
      __typename?: "DurationDetails";
      value: number;
      type: DurationType;
    } | null;
    principal?: { __typename?: "EmployerJobAdPrincipal"; name: string } | null;
    organization: { __typename?: "Organization"; name: string };
    tags: Array<{ __typename?: "JobAdTag"; id: string; name: string }>;
    location: {
      __typename?: "EmployerJobAdLocation";
      area: string;
      state: string;
      country: string;
    };
    categories: Array<{ __typename?: "Category"; name: string }>;
  } | null;
};

export type GetEmployerJobAdsQueryVariables = Exact<{
  dateFilter?: InputMaybe<EmployerJobAdsDateFilter>;
  employmentTypes: Array<EmploymentType> | EmploymentType;
}>;

export type GetEmployerJobAdsQuery = {
  __typename?: "Query";
  getEmployerJobAds: Array<{
    __typename?: "EmployerJobAd";
    companyName: string;
    applicationDeadline?: any | null;
    title: string;
    salary?: number | null;
    id: string;
    visibility: JobVisibility;
    employmentType: EmploymentType;
    createdAt: any;
    description: string;
    hasApplied: boolean;
    canApply: boolean;
    categories: Array<{ __typename?: "Category"; name: string }>;
    tags: Array<{ __typename?: "JobAdTag"; id: string; name: string }>;
    location: {
      __typename?: "EmployerJobAdLocation";
      area: string;
      state: string;
      country: string;
    };
    salaryDetails?: {
      __typename?: "SalaryDetails";
      starting: number;
      cap?: number | null;
      currencyCode: string;
    } | null;
    principal?: { __typename?: "EmployerJobAdPrincipal"; name: string } | null;
    organization: { __typename?: "Organization"; name: string };
    duration?: {
      __typename?: "DurationDetails";
      value: number;
      type: DurationType;
    } | null;
  }>;
};

export type AddSubscriberMutationVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type AddSubscriberMutation = {
  __typename?: "Mutation";
  addSubscriber: {
    __typename?: "MarketingSubscriber";
    id: string;
    emailAddress: string;
  };
};

export type ArtisanInvoiceQueryVariables = Exact<{
  invoiceId: Scalars["String"]["input"];
}>;

export type ArtisanInvoiceQuery = {
  __typename?: "Query";
  artisanInvoice?: {
    __typename?: "FilledArtisanInvoice";
    status: ArtisanInvoiceStatus;
    recipientAccountNumber: string;
    labor: number;
    invoiceNumber: number;
    createdAt: any;
    to: {
      __typename?: "ToDetails";
      name: string;
      phoneNumber: string;
      address: string;
    };
    user: {
      __typename?: "WhatsappUser";
      lastName: string;
      firstName: string;
      pro?: {
        __typename?: "Pro";
        associatedLaborHackEmail: string;
        paymentProviderInformation?: {
          __typename?: "PaymentProviderInformation";
          id: string;
          userId?: string | null;
          defaultAccountNumber: string;
          providerData: Array<{
            __typename?: "PaymentProviderData";
            accountNumber: string;
            providers: Array<{
              __typename?: "TransferRecipient";
              providerId: string;
              recipientCode: string;
              bankInformation?: {
                __typename?: "BankAccountInformation";
                accountName: string;
                accountNumber: string;
                bankName?: string | null;
              } | null;
            }>;
          }>;
        } | null;
      } | null;
    };
    task: {
      __typename?: "ArtisanInvoiceTask";
      description: string;
      name: string;
    };
    materials: Array<{
      __typename?: "ArtisanInvoiceMaterial";
      name: string;
      quantity: number;
      unitCost: number;
    }>;
    from: { __typename?: "FromDetails"; name: string; address?: string | null };
  } | null;
};

export const HomeownerFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HomeownerFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HomeownerRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "otherCategoryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "interval" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "package" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "invoice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appliedDiscount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "formattedAddress" },
                },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "state" } },
                { kind: "Field", name: { kind: "Name", value: "placeId" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "frequency" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "isPaid" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "isComplete" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HomeownerFieldsFragment, unknown>;
export const GetUserProfilesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserProfiles" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myPro" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "myClient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserProfilesQuery,
  GetUserProfilesQueryVariables
>;
export const FinalizeHomeownerRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "FinalizeHomeownerRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "finalizeHomeownerRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "isComplete" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FinalizeHomeownerRequestMutation,
  FinalizeHomeownerRequestMutationVariables
>;
export const GetHomeownerRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetHomeownerRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "homeownerRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HomeownerFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HomeownerFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HomeownerRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "otherCategoryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "interval" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "package" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "invoice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appliedDiscount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "formattedAddress" },
                },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "state" } },
                { kind: "Field", name: { kind: "Name", value: "placeId" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "frequency" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "isPaid" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "isComplete" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetHomeownerRequestQuery,
  GetHomeownerRequestQueryVariables
>;
export const UpdateHomeownerRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateHomeownerRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "category" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "otherCategoryText" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "plan" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "description" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "address" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AddressInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "addressId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "frequency" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "HomeownerRequestTaskFrequency" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTimeISO" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstName" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastName" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phoneNumber" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "leadSource" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "otherLeadSourceText" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateHomeownerRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "category" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "category" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "otherCategoryText" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "otherCategoryText" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "description" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "description" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "plan" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "plan" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "address" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "address" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "addressId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "addressId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "frequency" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "frequency" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "firstName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "firstName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lastName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lastName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phoneNumber" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phoneNumber" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "leadSource" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "leadSource" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "otherLeadSourceText" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "otherLeadSourceText" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HomeownerFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HomeownerFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HomeownerRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addresses" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "otherCategoryText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "plan" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "interval" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "package" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "invoice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appliedDiscount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "formattedAddress" },
                },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "state" } },
                { kind: "Field", name: { kind: "Name", value: "placeId" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "frequency" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "isPaid" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "isComplete" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateHomeownerRequestMutation,
  UpdateHomeownerRequestMutationVariables
>;
export const CreateCommunityManagementDemoRequestTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateCommunityManagementDemoRequestTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "communityManagementDemoRequestDto" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CommunityManagementDemoRequestDto",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createCommunityManagementDemoRequestTask",
            },
            arguments: [
              {
                kind: "Argument",
                name: {
                  kind: "Name",
                  value: "communityManagementDemoRequestDto",
                },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "communityManagementDemoRequestDto",
                  },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateCommunityManagementDemoRequestTaskMutation,
  CreateCommunityManagementDemoRequestTaskMutationVariables
>;
export const CreateCommunityManagementSalesConversationTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "CreateCommunityManagementSalesConversationTask",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "communityManagementSalesConversationRequestDto",
            },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CommunityManagementSalesConversationRequestDto",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createCommunityManagementSalesConversationTask",
            },
            arguments: [
              {
                kind: "Argument",
                name: {
                  kind: "Name",
                  value: "communityManagementSalesConversationRequestDto",
                },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "communityManagementSalesConversationRequestDto",
                  },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateCommunityManagementSalesConversationTaskMutation,
  CreateCommunityManagementSalesConversationTaskMutationVariables
>;
export const ClientExistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ClientExist" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clientExists" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientExistQuery, ClientExistQueryVariables>;
export const CreateHomeownerRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateHomeownerRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "categoryId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "otherCategoryText" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "description" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstName" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastName" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "planId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createHomeownerRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "categoryId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "categoryId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "otherCategoryText" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "otherCategoryText" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "description" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "description" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "firstName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "firstName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lastName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lastName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "planId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "planId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateHomeownerRequestMutation,
  CreateHomeownerRequestMutationVariables
>;
export const LogOutOfLagosHomeownerRequestAttemptDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LogOutOfLagosHomeownerRequestAttempt" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "state" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "city" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "address" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "homeownerRequestId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "logOutOfLagosHomeownerRequestAttempt",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "state" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "state" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "city" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "city" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "address" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "address" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "homeownerRequestId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "homeownerRequestId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LogOutOfLagosHomeownerRequestAttemptMutation,
  LogOutOfLagosHomeownerRequestAttemptMutationVariables
>;
export const CreateCustomSubscriptionRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateCustomSubscriptionRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phoneNumber" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accountType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CustomSubscriptionRequestAccountType",
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "duration" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "specificRequirements" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "categoryId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createCustomSubscriptionRequest" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phoneNumber" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phoneNumber" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accountType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "duration" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "duration" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "specificRequirements" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "specificRequirements" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "categoryId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "categoryId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateCustomSubscriptionRequestMutation,
  CreateCustomSubscriptionRequestMutationVariables
>;
export const StartHomeownerRequestPaymentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StartHomeownerRequestPayment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "discountCode" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "startHomeownerRequestPayment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "discountCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "discountCode" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invoice" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "appliedDiscount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isPaid" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartHomeownerRequestPaymentMutation,
  StartHomeownerRequestPaymentMutationVariables
>;
export const CategorySubscriptionPackagePlanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CategorySubscriptionPackagePlan" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "discount" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value:
                "CategorySubscriptionPackagePlanCostBreakdownDiscountOptions",
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "categorySubscriptionPackagePlan" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "planId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "package" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "costBreakdown" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "discount" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "discount" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subTotal" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "discount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "tax" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transactionFee" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CategorySubscriptionPackagePlanQuery,
  CategorySubscriptionPackagePlanQueryVariables
>;
export const AvailableAutoAppliedInvoiceDiscountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AvailableAutoAppliedInvoiceDiscount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invoiceType" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InvoiceType" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "availableAutoAppliedInvoiceDiscount",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invoiceType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invoiceType" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "valueCap" } },
                { kind: "Field", name: { kind: "Name", value: "balance" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AvailableAutoAppliedInvoiceDiscountQuery,
  AvailableAutoAppliedInvoiceDiscountQueryVariables
>;
export const ConfirmHomeownerRequestPaymentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConfirmHomeownerRequestPayment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "homeownerRequestId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "transactionReference" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmHomeownerRequestPayment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "homeownerRequestId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "homeownerRequestId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "transactionReference" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "transactionReference" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "isPaid" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmHomeownerRequestPaymentMutation,
  ConfirmHomeownerRequestPaymentMutationVariables
>;
export const GetInvoiceDiscountByCodeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetInvoiceDiscountByCode" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "invoiceDiscountByCode" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "code" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "balance" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInvoiceDiscountByCodeQuery,
  GetInvoiceDiscountByCodeQueryVariables
>;
export const CanApplyDiscountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CanApplyDiscount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invoiceType" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InvoiceType" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "canApplyInvoiceDiscount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "discountCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "invoiceType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invoiceType" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CanApplyDiscountQuery,
  CanApplyDiscountQueryVariables
>;
export const GetShareableApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetShareableApplication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getShareableApplication" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applicant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phoneNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jobTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "yearsOfExperience" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "education" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "schoolName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fieldOfStudy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "qualification" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employmentHistory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "companyName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jobTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "media" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mimeType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "originalUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnailUrl" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "projectHistory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "media" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mimeType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "originalUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnailUrl" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "videos" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "certifications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issuedBy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issuedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issuerCertificationId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetShareableApplicationQuery,
  GetShareableApplicationQueryVariables
>;
export const MyJobApplicationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MyJobApplications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myJobApplications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "education" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "schoolName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fieldOfStudy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "qualification" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employmentHistory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "companyName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jobTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "media" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mimeType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "originalUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnailUrl" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "projectHistory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "media" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mimeType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "originalUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnailUrl" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "videos" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "certifications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issuerCertificationId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issuedBy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issuedAt" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MyJobApplicationsQuery,
  MyJobApplicationsQueryVariables
>;
export const MyPortfolioForJobApplicationPrefillDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MyPortfolioForJobApplicationPrefill" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myPortfolio" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workHistory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "images" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mimeType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "originalUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnailUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employmentHistory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "companyName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jobTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "images" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "key" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mimeType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "originalUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnailUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "certifications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issuedBy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issuedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issuerCertificationId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "educationEntries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "schoolName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fieldOfStudy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "qualification" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MyPortfolioForJobApplicationPrefillQuery,
  MyPortfolioForJobApplicationPrefillQueryVariables
>;
export const DoesProExistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DoesProExist" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "doesProExistWithEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DoesProExistQuery, DoesProExistQueryVariables>;
export const DoesApplicantExistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DoesApplicantExist" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "doesApplicantExistWithEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DoesApplicantExistQuery,
  DoesApplicantExistQueryVariables
>;
export const MyJobApplicantProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MyJobApplicantProfile" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myJobApplicantProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "yearsOfExperience" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pro" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MyJobApplicantProfileQuery,
  MyJobApplicantProfileQueryVariables
>;
export const CreateRecruiterJobApplicationLoggedInDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateRecruiterJobApplicationLoggedIn" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateJobApplicationDto" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createRecruiterJobApplicationLoggedIn",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applicant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pro" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applicantSnapshot" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phoneNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "yearsOfExperience" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateRecruiterJobApplicationLoggedInMutation,
  CreateRecruiterJobApplicationLoggedInMutationVariables
>;
export const CreateRecruiterJobApplicationNotLoggedInDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateRecruiterJobApplicationNotLoggedIn" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateJobApplicationDto" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "createRecruiterJobApplicationNotLoggedIn",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applicant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pro" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applicantSnapshot" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phoneNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "yearsOfExperience" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateRecruiterJobApplicationNotLoggedInMutation,
  CreateRecruiterJobApplicationNotLoggedInMutationVariables
>;
export const AddPortfolioCertificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddPortfolioCertification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "issuedBy" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "issuerCertificationId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "issuedAt" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DateTimeISO" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addPortfolioCertification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "issuedBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "issuedBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "issuerCertificationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "issuerCertificationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "issuedAt" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "issuedAt" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddPortfolioCertificationMutation,
  AddPortfolioCertificationMutationVariables
>;
export const EditPortfolioCertificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "EditPortfolioCertification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "issuedBy" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "issuerCertificationId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "issuedAt" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTimeISO" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "url" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "editPortfolioCertification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "issuedBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "issuedBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "issuerCertificationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "issuerCertificationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "issuedAt" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "issuedAt" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "url" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "url" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "issuedBy" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "issuerCertificationId" },
                },
                { kind: "Field", name: { kind: "Name", value: "issuedAt" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditPortfolioCertificationMutation,
  EditPortfolioCertificationMutationVariables
>;
export const RemovePortfolioCertificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemovePortfolioCertification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removePortfolioCertification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemovePortfolioCertificationMutation,
  RemovePortfolioCertificationMutationVariables
>;
export const ToggleEmploymentHistoryItemPinDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ToggleEmploymentHistoryItemPin" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "togglePortfolioEmploymentHistoryItemPin",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "isPinned" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ToggleEmploymentHistoryItemPinMutation,
  ToggleEmploymentHistoryItemPinMutationVariables
>;
export const ProPortfolioWithoutMediaDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProPortfolioWithoutMedia" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "handle" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "proPortfolio" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "handle" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "handle" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isEmailHidden" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employmentHistory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isPinned" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "companyName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jobTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "images" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mimeType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "originalUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnailUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deletedAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workHistory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "images" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mimeType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "originalUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnailUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deletedAt" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "clientReview" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rating" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "feedback" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "verified" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isPinned" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundCheckStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "identityVerificationStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "certifications" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issuedBy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issuedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "issuerCertificationId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "verified" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "educationEntries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "schoolName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fieldOfStudy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "qualification" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "verified" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "averageRating" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "averageLaborHackJobsRatings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "averageAppearanceRating",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "averagePunctualityRating",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "averagePostServiceCleanUpRating",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "averageBehaviorRating" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "averageProperToolUsageRating",
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "ratingCount" } },
                { kind: "Field", name: { kind: "Name", value: "overview" } },
                { kind: "Field", name: { kind: "Name", value: "experience" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProPortfolioWithoutMediaQuery,
  ProPortfolioWithoutMediaQueryVariables
>;
export const TogglePortfolioWorkHistoryItemPinDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "TogglePortfolioWorkHistoryItemPin" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "togglePortfolioWorkHistoryItemPin" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "isPinned" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TogglePortfolioWorkHistoryItemPinMutation,
  TogglePortfolioWorkHistoryItemPinMutationVariables
>;
export const CreateProjectOutsourcingTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createProjectOutsourcingTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "projectOutsourcingDto" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ProjectOutsourcingDto" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createProjectOutsourcingTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectOutsourcingDto" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "projectOutsourcingDto" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateProjectOutsourcingTaskMutation,
  CreateProjectOutsourcingTaskMutationVariables
>;
export const RequestConstructionProjectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "requestConstructionProject" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "constructionProjectRequestDto" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ConstructionProjectRequestDto" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "requestConstructionProject" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "constructionProjectRequestDto" },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "constructionProjectRequestDto",
                  },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestConstructionProjectMutation,
  RequestConstructionProjectMutationVariables
>;
export const RequestFacilityMaintenanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "requestFacilityMaintenance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "facilityMaintenanceRequestDto" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FacilityMaintenanceRequestDto" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "requestFacilityMaintenance" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "facilityMaintenanceRequestDto" },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "facilityMaintenanceRequestDto",
                  },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestFacilityMaintenanceMutation,
  RequestFacilityMaintenanceMutationVariables
>;
export const RequestRenovationProjectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "requestRenovationProject" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "renovationProjectRequestDto" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RenovationProjectRequestDto" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "requestRenovationProject" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "renovationProjectRequestDto" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "renovationProjectRequestDto" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestRenovationProjectMutation,
  RequestRenovationProjectMutationVariables
>;
export const CreateRecruitmentConsultationTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createRecruitmentConsultationTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "recruitmentConsultationDto" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RecruitmentConsultationDto" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createRecruitmentConsultationTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "recruitmentConsultationDto" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "recruitmentConsultationDto" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateRecruitmentConsultationTaskMutation,
  CreateRecruitmentConsultationTaskMutationVariables
>;
export const CreateLeadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateLead" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phoneNumber" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "referrer" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "source" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createLead" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "phone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phoneNumber" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "referrer" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "referrer" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "source" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "source" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateLeadMutation, CreateLeadMutationVariables>;
export const RegisterNewClientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "registerNewClient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RegisterNewClientInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registerNewClient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegisterNewClientMutation,
  RegisterNewClientMutationVariables
>;
export const CategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Categories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeCustomPackages" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "categories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "proTitle" } },
                { kind: "Field", name: { kind: "Name", value: "imageUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestCount" },
                },
                { kind: "Field", name: { kind: "Name", value: "priority" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "packages" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "includeCustomPackages" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "includeCustomPackages" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maximumCalls" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "baseInterval" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isCustom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "plans" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "interval" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "discount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "costBreakdown" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "discount" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "subTotal" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tax" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "total" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "price" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CategoriesQuery, CategoriesQueryVariables>;
export const GetUserByEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserByEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserRecordByEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserByEmailQuery, GetUserByEmailQueryVariables>;
export const GetUserByPhoneNumberDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserByPhoneNumber" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phoneNumber" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserRecordByPhoneNumber" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "phoneNumber" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phoneNumber" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserByPhoneNumberQuery,
  GetUserByPhoneNumberQueryVariables
>;
export const GetBusinessByEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetBusinessByEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "businessByEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBusinessByEmailQuery,
  GetBusinessByEmailQueryVariables
>;
export const GetMyLocationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMyLocations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getMyLocations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultLocationId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "buildingNumber" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "streetName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "landmark" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "area" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyLocationsQuery, GetMyLocationsQueryVariables>;
export const MyClientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MyClient" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myClient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MyClientQuery, MyClientQueryVariables>;
export const LogServerEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LogServerEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "event" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EventTypes" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "LogEventContextFieldArgs" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "logEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "event" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "context" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LogServerEventMutation,
  LogServerEventMutationVariables
>;
export const GetMyProProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMyProProfile" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "myProInformation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "yearsOfExperience" },
                },
                { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "proApplication" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dateOfBirth" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gender" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "detailedAddress" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "state" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "placeId" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "overview" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMyProProfileQuery,
  GetMyProProfileQueryVariables
>;
export const MarkApprovalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MarkApproval" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "token" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contacts" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "CreateBusinessClientInput" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "markBusinessAsApproved" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "token" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "contacts" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "contacts" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "client" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkApprovalMutation,
  MarkApprovalMutationVariables
>;
export const GetActivationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetActivation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "token" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accountActivationByToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "token" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "client" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActivationQuery, GetActivationQueryVariables>;
export const SaveBusinessDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SaveBusiness" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "payload" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SaveBusinessInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saveBusiness" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "payload" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clients" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phoneNumber" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveBusinessMutation,
  SaveBusinessMutationVariables
>;
export const WaitlistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WAITLIST" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateWaitlistedBusinessInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "waitlistBusiness" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contacts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WaitlistMutation, WaitlistMutationVariables>;
export const ResendDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RESEND" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "resendWaitlistedBusinessVerificationCode",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResendMutation, ResendMutationVariables>;
export const VerifyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "VERIFY" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "verifyWaitlistedBusinessVerificationCode",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "code" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contacts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emailVerified" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifyMutation, VerifyMutationVariables>;
export const CreateEnquiryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateEnquiry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phoneNumber" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accountType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AccountType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "message" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "joinedMailingList" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createEnquiry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phoneNumber" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phoneNumber" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accountType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "message" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "message" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "joinedMailingList" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "joinedMailingList" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateEnquiryMutation,
  CreateEnquiryMutationVariables
>;
export const ListClientInvoicesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ListClientInvoices" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getClientInvoices" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "canceled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inspectionAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invoiceNumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "invoiceDate" } },
                { kind: "Field", name: { kind: "Name", value: "due" } },
                { kind: "Field", name: { kind: "Name", value: "discount" } },
                { kind: "Field", name: { kind: "Name", value: "isFullyPaid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasAtLeastOnePayment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "progress" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "order" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orderCode" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "inspectionPayment",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "amount" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "locationSchedules",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "locationId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "scheduledDate",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isEmergency" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jobs" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "jobCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "custom" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "resourceUrl",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "subCategoryId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "categoryId" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "task" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "estimatedCost",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "categoryId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "subCategoryId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "imageUrl" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "finalCost" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "completedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "payment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "transactionReference",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "transactionDate",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "amount" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contact" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "notes" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "location" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "buildingNumber",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "streetName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "area" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "location",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "landmark",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "city" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "invoiceDetails" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "materials" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "unitPrice",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "quantity",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "labor" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phoneNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transactionDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transactionReference" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "splitPayments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "percentage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "transactionDate" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "transactionReference",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListClientInvoicesQuery,
  ListClientInvoicesQueryVariables
>;
export const AddLocationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "addLocation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AddLocationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addLocation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddLocationMutation, AddLocationMutationVariables>;
export const SetLocationAsDefaultDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetLocationAsDefault" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setLocationAsDefault" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetLocationAsDefaultMutation,
  SetLocationAsDefaultMutationVariables
>;
export const ListClientOrdersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ListClientOrders" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clientOrders" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "orderCode" } },
                { kind: "Field", name: { kind: "Name", value: "categories" } },
                { kind: "Field", name: { kind: "Name", value: "taskCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inspectionFeePaid" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCost" } },
                { kind: "Field", name: { kind: "Name", value: "assigned" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListClientOrdersQuery,
  ListClientOrdersQueryVariables
>;
export const CreateReviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createReview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateReviewInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createReview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateReviewMutation,
  CreateReviewMutationVariables
>;
export const CreateReferralDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createReferral" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "referredEmail" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createReferral" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "referredEmail" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "referredEmail" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateReferralMutation,
  CreateReferralMutationVariables
>;
export const UpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Update" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "payload" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EditClientInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateClient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "payload" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "payload" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastNotificationViewedAt" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMutation, UpdateMutationVariables>;
export const EditUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "EditUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstName" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastName" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "phoneNumber" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "firstName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "firstName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lastName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lastName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phoneNumber" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "phoneNumber" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditUserMutation, EditUserMutationVariables>;
export const GetOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "orderCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "client" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phoneNumber" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locationSchedules" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledDate" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "jobs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jobCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "custom" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "resourceUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "subCategoryId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "categoryId" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "task" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "estimatedCost" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "categoryId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "subCategoryId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageUrl" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "finalCost" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "completedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "transactionReference",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "transactionDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contact" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "notes" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "buildingNumber",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "streetName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "area" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "location" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "landmark" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "city" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invoiceDetails" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "materials" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "unitPrice" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "quantity" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "labor" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isEmergency" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "progress" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "inspectionPayment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "transactionReference",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "transactionDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "inspectionWaived" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invoice" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "invoiceNumber" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "invoiceDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sent" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inspectionAmount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isFullyPaid" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "hasAtLeastOnePayment",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "payment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "amount" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "transactionReference",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "transactionDate",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "splitPayments" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "percentage" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "payment" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "status",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "amount",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "transactionDate",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jobs" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "jobCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "custom" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "resourceUrl",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "subCategoryId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "categoryId" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "task" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "estimatedCost",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "categoryId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "subCategoryId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "imageUrl" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "finalCost" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "completedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "payment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "transactionReference",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "transactionDate",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "amount" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contact" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "notes" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "location" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "buildingNumber",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "streetName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "area" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "location",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "landmark",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "city" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "invoiceDetails" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "materials" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "unitPrice",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "quantity",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "labor" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tradesman" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "level" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "categoryId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rewardPoints" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rating" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "buildingNumber",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "streetName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "area" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "location" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "landmark" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "city" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "phoneNumber" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrderQuery, GetOrderQueryVariables>;
export const GetInvoicesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetInvoices" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "InvoiceType" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getInvoicesByOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "type" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "type" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "sent" } },
                { kind: "Field", name: { kind: "Name", value: "canceled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inspectionAmount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invoiceNumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "invoiceDate" } },
                { kind: "Field", name: { kind: "Name", value: "discount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appliedDiscount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "isFullyPaid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasAtLeastOnePayment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "splitPayments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "percentage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "transactionDate" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "progress" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "order" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orderCode" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "inspectionPayment",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "amount" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "locationSchedules",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "locationId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "scheduledDate",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isEmergency" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "jobs" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "jobCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "custom" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "resourceUrl",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "subCategoryId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "categoryId" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "task" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "estimatedCost",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "categoryId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "subCategoryId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "imageUrl" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "finalCost" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "completedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "payment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "transactionReference",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "transactionDate",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "amount" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contact" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "notes" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "location" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "buildingNumber",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "streetName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "area" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "location",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "landmark",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "city" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "invoiceDetails" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "materials" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "unitPrice",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "quantity",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "labor" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "date" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phoneNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transactionDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transactionReference" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetNotificationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "GetNotifications" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "newClientNotification" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "event" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InvoiceNotificationPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invoice" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "invoiceId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "invoiceNumber" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "order" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orderCode" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "TextNotificationPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "text" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "body" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetNotificationsSubscription,
  GetNotificationsSubscriptionVariables
>;
export const ConfirmInvoicePaymentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConfirmInvoicePayment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invoiceId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "transactionId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmInvoicePayment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invoiceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invoiceId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "transactionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "transactionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmInvoicePaymentMutation,
  ConfirmInvoicePaymentMutationVariables
>;
export const ActivateJobDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ActivateJob" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "jobId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "activateJob" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "jobId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "jobId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivateJobMutation, ActivateJobMutationVariables>;
export const ArchiveJobDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ArchiveJob" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "jobId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "archiveJob" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "jobId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "jobId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArchiveJobMutation, ArchiveJobMutationVariables>;
export const GetInvoicePaymentLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GetInvoicePaymentLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invoiceId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "providerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "callback" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getInvoicePaymentLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invoiceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invoiceId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "providerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "providerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "callback" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "callback" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "paymentUrl" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInvoicePaymentLinkMutation,
  GetInvoicePaymentLinkMutationVariables
>;
export const ApplyDiscountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ApplyDiscount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invoiceId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "discountCode" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "applyInvoiceDiscountCode" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invoiceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invoiceId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "discountCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "discountCode" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "discount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appliedDiscount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplyDiscountMutation,
  ApplyDiscountMutationVariables
>;
export const GetPaymentProvidersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaymentProviders" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "amount" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "paymentProviders" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transactionFee" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "amount" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "amount" },
                      },
                    },
                  ],
                },
                { kind: "Field", name: { kind: "Name", value: "isActive" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPaymentProvidersQuery,
  GetPaymentProvidersQueryVariables
>;
export const GetNextInvoicePaymentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetNextInvoicePayment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invoiceId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "nextInvoicePayment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invoiceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invoiceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "total" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "serviceCharge" },
                },
                { kind: "Field", name: { kind: "Name", value: "discount" } },
                { kind: "Field", name: { kind: "Name", value: "subTotal" } },
                { kind: "Field", name: { kind: "Name", value: "materials" } },
                { kind: "Field", name: { kind: "Name", value: "labor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "laborHackFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextPaymentPercentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "laborCommission" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "materialCommission" },
                },
                { kind: "Field", name: { kind: "Name", value: "tax" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetNextInvoicePaymentQuery,
  GetNextInvoicePaymentQueryVariables
>;
export const GetInvoiceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetInvoice" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invoiceId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getInvoiceById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invoiceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invoiceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canceled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "inspectionAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invoiceNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invoiceDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isFullyPaid" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasAtLeastOnePayment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "renderingData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "headers" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sections" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "rows" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "cells",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "subText",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "text",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pricing" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "options" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "hideServiceCharge",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "serviceCharge" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cost" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reimbursements" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "excludeTax" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "payout" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "worksheet" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "contract",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "pro",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "firstName",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "lastName",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "payroll",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "period",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "start",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "end",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "breakdown" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "gross",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "net" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "tax" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "marketplaceRequest" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "jobs" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "trade" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "matches" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "pro" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "recruitment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "jobs" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "category" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "matches" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "pro" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "recruitmentData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contract" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "contractInterval",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "contractLength",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "pro" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "firstName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lastName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "categoryId",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "proLevel" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "period" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "start" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "end" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "numberOfBilledDays",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "agreedDailyRate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "allowedPaymentProviders",
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "due" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "discount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "appliedDiscount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "value" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assignments" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "progress" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "order" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "orderCode" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "inspectionPayment",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "status",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "amount",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "locationSchedules",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "locationId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "scheduledDate",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isEmergency",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "jobs" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "jobCode" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "custom" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "resourceUrl",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "subCategoryId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "categoryId",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "task" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "estimatedCost",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "categoryId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "subCategoryId",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "imageUrl",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "finalCost" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "completedAt",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "payment" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "transactionReference",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "transactionDate",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "amount",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "status",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "contact" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "notes",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "location",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "buildingNumber",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "streetName",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "area",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "location",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "landmark",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "city",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "invoiceDetails",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "materials",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "unitPrice",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "quantity",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "labor",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "recipient" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "phoneNumber" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "transactionDate" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "transactionReference",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "splitPayments" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "percentage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "payment" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "transactionDate",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "transactionReference",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "amount" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetInvoiceQuery, GetInvoiceQueryVariables>;
export const GetJobAdForApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetJobAdForApplication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getEmployerJobAd" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employmentType" },
                },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "principal" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "area" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "salaryDetails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "starting" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "cap" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currencyCode" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "duration" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tags" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categories" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "hasApplied" } },
                { kind: "Field", name: { kind: "Name", value: "canApply" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetJobAdForApplicationQuery,
  GetJobAdForApplicationQueryVariables
>;
export const UpdateGuestApplicantUserIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateGuestApplicantUserId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateGuestApplicantUserId" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateGuestApplicantUserIdMutation,
  UpdateGuestApplicantUserIdMutationVariables
>;
export const GetJobAdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetJobAd" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getEmployerJobAd" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "salaryDetails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "starting" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "cap" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currencyCode" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employmentType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "duration" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "principal" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "visibility" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tags" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "area" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categories" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "hasApplied" } },
                { kind: "Field", name: { kind: "Name", value: "canApply" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applicationDeadline" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetJobAdQuery, GetJobAdQueryVariables>;
export const GetEmployerJobAdsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEmployerJobAds" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateFilter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EmployerJobAdsDateFilter" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "employmentTypes" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "EmploymentType" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getEmployerJobAds" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateFilter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateFilter" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "employmentTypes" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "employmentTypes" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "categories" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tags" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "applicationDeadline" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "area" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "salary" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "salaryDetails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "starting" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "cap" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currencyCode" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "principal" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "visibility" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "employmentType" },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "hasApplied" } },
                { kind: "Field", name: { kind: "Name", value: "canApply" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "duration" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEmployerJobAdsQuery,
  GetEmployerJobAdsQueryVariables
>;
export const AddSubscriberDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddSubscriber" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "addSubscriber" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "emailAddress" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddSubscriberMutation,
  AddSubscriberMutationVariables
>;
export const ArtisanInvoiceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ArtisanInvoice" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invoiceId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "artisanInvoice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invoiceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invoiceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "to" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phoneNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pro" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "associatedLaborHackEmail",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "paymentProviderInformation",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "userId" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "defaultAccountNumber",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "providerData",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "accountNumber",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "providers",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "providerId",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "recipientCode",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "bankInformation",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "accountName",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "accountNumber",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "bankName",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "task" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipientAccountNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "materials" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "quantity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unitCost" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "labor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invoiceNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "from" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArtisanInvoiceQuery, ArtisanInvoiceQueryVariables>;
